import * as React from 'react'
import {General, Rewards, Chances, Accounting, Reports, RGSpecialist, RFSpecialist, Marketing, Operator, Support, Administrator, Tournaments, GiftShop, Promotions, Gamification, KnowYourCustomer, ResponsibleGaming, RiskManagement, Transactions, GameSessions, PlayerTimeline, IncreasedNetLoss, InitiatedCoolOffs, HigherNetLoss, GamingTime, CancelledWithdrawals, DepositAfterCoolOff, DepositMethods, BlacklistCheck, DashboardBackend, SelfAssessment, PermanentExclusion, ResponsibleGamingIssues, NetLimitLossRegistration, TemporaryExclude, RiskManagementIssues, InternalPlayerRisk, ProvisionalAccountStatus, NoPlayerActivity, LargeDeposits, LargeWithdrawals, MaximumAmountOnPlayerWallet, KnowYourCustomerIssues, NetLimitLoss, _and_, Races} from './Assets'
import {/*faClipboardList, faExchangeAlt,*/faDiceD20, faFileCsv, faCode, faFire, IconDefinition, faRuler, faExclamationCircle, /*faAllergies, faCut,*/ faGlobeAsia, faMailBulk, faLaptopCode, faSitemap, faAddressCard, faMagic, faIdCardAlt/*faBalanceScale, faServer*/, faTasks, faGlobeAmericas, faGlobe, faUserCircle/*, faPager*/, faAddressBook, faTags, faGlobeEurope, faMoneyBillWave/*, faStopwatch, faBell*/, faHandsHelping, faUserTie, faDice, faUserShield, faUserFriends, faUser, faBullhorn, faUserCheck, faUserInjured, faUserSecret, faChartLine,/*, faChartArea, faTrophy, faGift, faGifts, faClock,*/ faExclamationTriangle/*, faFileUpload*/, faUsers/*, faClipboardList*/} from '@fortawesome/free-solid-svg-icons'
import {faUserCircle as faUserCircle2, faSnowflake, faCreditCard} from '@fortawesome/free-regular-svg-icons'
import {AgeGroup} from '../Logic/Database/DatabaseData'
export const SecurityRightsIcons: IconDefinition[] = [faUserShield, faUserFriends, faUser, faBullhorn, faUserCheck, faUserInjured, faUserSecret, faUserTie, faChartLine, faFire, faDice, faMagic]
export const GamanzaAdministrator: string = 'Gamanza Administrator'
export const SelectedViewIcons: IconDefinition[] = [faChartLine, faTasks, faDiceD20, faUsers, /*faServer, faServer, faServer,*/ faFileCsv, faExclamationTriangle, faHandsHelping, faAddressBook, faDiceD20, faTasks]
export const GamanzaGamesAdministrator: string = 'Gamanza Games Administrator'
export const SelectedGenericSettingIcons: IconDefinition[] = [faGlobeEurope, faMoneyBillWave, faSnowflake/*, faClipboardList*//*, faPager*//*, faAddressCard, faGlobeAsia*/]
export const SelectedGamesSettingIcons: IconDefinition[] = [faSitemap, faTags/*, faAllergies*/, faGlobeAmericas, faLaptopCode]
export const SelectedFrontEndSettingIcons: IconDefinition[] = [faSitemap, faTags, faGlobeAmericas, faLaptopCode]
export const SelectedRiskComplianceSettingIcons: IconDefinition[] = [faSnowflake, faRuler, faExclamationTriangle, faHandsHelping, faAddressBook, faUserCircle, faExclamationCircle, faExclamationTriangle]
export const SelectedPlayerSettingIcons: IconDefinition[] = [faIdCardAlt, faGlobeEurope, faGlobeAsia, faMailBulk, faGlobe, faTags, faAddressCard]
export const SelectedAdminSettingIcons: IconDefinition[] = [faUserCircle2, faGlobeAsia, faCode/*, faClipboardList*/]
export const SelectedPaymentSettingIcons: IconDefinition[] = [faCreditCard]
export const KEY_ENTER: string = 'Enter'
import {environment, Environment} from '../Logic/Config'
/* Product version */
export const productVersion: string = process.env.REACT_APP_DATE ? process.env.REACT_APP_DATE : 'v0.0.1'
export const Gamanza: string = 'Gamanza'
export enum RT {BOOST_GLOBAL = 0, BOOST_PLAYER_SPECIFIC, CASH_BACK, CASH_BONUS, DEPOSIT_BONUS, FREE_SPINS, MINI_GAME, TOKENS, MEGA_SPINS, ITEMS}
// export const RTCategories: string[] = ['Free spins', 'Cash bonus', 'Tokens', 'Cash back', 'Mini game', 'Deposit bonus', 'Boost global', 'Boost player specific']
// export const RTCategoriesMyChance: string[] = ['Free spins', 'Bonus money', 'Tokens', 'Mega spins', 'Specials']
export const RTFreeSpinsAmount: string[] = ['10FS', '25FS', '50FS', '100FS']
export const RTMegaSpinsAmount: string[] = ['10MS', '25MS', '50MS', '100MS']
// export enum RewardTypes {All = 0, FreeSpins, CashBonus, Tokens, CashBack, MiniGame, DepositBonus, BoosterGlobal, BoosterPlayerSpecific, MegaSpins, Specials}
export const GameCategoryIncluded: string[] = environment === Environment.PRODUCTION ? ['Slots', 'Video Poker', 'Table Games', 'Jackpot Games', 'Live Casino'] : ['Slots', 'Video Poker', 'Table Games', 'Lottery Games', 'Live Dealer', 'Scratch Cards', 'Desktop', 'Nano', 'Roulette', 'Black Jack']
// export const RTCategoriesBackend: string[] = ['Free spins', 'Cash bonus', 'Tokens', 'Deposit bonus', 'Boost global', 'Boost player specific']
export const Unknown: string = 'Unknown'
/*
export type Order = {
    group:number
    index:number
    instance:number
}

export type Instance = {
    name:string
    version:string
}
*/
export const GamanzaMagicHand: string = 'Gamanza Magic Hand'
/*
export type Instance = {
        name:string
        version:string
}
*/
/*
export type Menu = {
    name:string
    type:string
}
export type Group = {
    name:string
}
*/
export const lorem: string = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'
export const slots = 'slots'
/* Require */
export const fr18 = require('../Assets/fr18.png').default
export const sfr18 = require('../Assets/sfr18.png').default
// export const switzerlandFlag = require('../Assets/ch.png')
// export const scandibetBFShop = require('../Assets/rsbf.png')
// export const scandibetBFShopSmall = require('../Assets/rsbfs.png')
// export const scandibetShopSmall = require('../Assets/RewardShopSmall.png')
// export const scandibetShop = require('../Assets/RewardShop.png')
// export const scandibetShopRight = require('../Assets/RewardShop2.png')
export const checkered = require('../Assets/Checkered.png').default
export const active = require('../Assets/green_bullet.png').default
export const inactive = require('../Assets/red_bullet.png').default
export const active2 = require('../Assets/greenbullet.png').default
export const inactive2 = require('../Assets/redbullet.png').default
export const logo = require('../Assets/logo.png').default
export const logoGamanza = require('../Assets/logo_gamanza.png').default
export const logoImage = require('../Assets/logo-white.png').default
export const logoWhite = require('../Assets/logo-white-.png').default
export const logoBlack = require('../Assets/logo-black.png').default

// export const test = require('../Assets/test.pdf')
export const zeroPng: string =
'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR4nGP6zwAAAgcBApocMXEAAAAASUVORK5CYII='
export const validImageFileLength: number = 20000
/* Require temporary */
export const jackpotsLogo: string = require('../Assets/jackpots.png').default
export const myChanceLogo: string = require('../Assets/mychance.png').default
export const badenLogo: string = require('../Assets/baden.png').default
export const pasinoLogo = require('../Assets/logo_pasino.png').default

export const errorCodes = require('../Assets/errcode.json')
export const exErrorCodes = require('../Assets/exerrcodes.json')
// export const lists: string[] = [require('../Assets/0.txt'), require('../Assets/10.txt'), require('../Assets/100.txt')]
export const Lists: number[] = [0, 10, 100]

export const lists: number[][] = [
    [
        2245,
        3538,
        2535,
        3613,
        1273,
        3544,
        2956,
        3160,
        3317,
        6682,
        1059,
        3387,
        5918,
        2702,
        891,
        1944,
        1700,
        1271,
        3388,
        1313,
        3328,
        2639,
        2509,
        2814,
        2450,
        2775,
        2243,
        4924,
        2484,
        3587,
        2569,
        1636,
        1272,
        1897,
        1866,
        3616,
        3119,
        3331,
        3384,
        2565,
        3344,
        2002,
        3167,
        2867,
        3504,
        3642,
        2969,
        893,
        3154,
        3177,
        839,
        3534,
        3489,
        998,
        4285,
        2927,
        3967,
        2978,
        5911,
        2909,
        3302,
        1503,
        2637,
        2643,
        2445,
        1138,
        3347,
        3497,
        1408,
        1151,
        1401,
        3485,
        1397,
        502,
        530,
        786,
        535,
        536,
        1943,
        1975,
        1976,
        983,
        1194,
        3963,
        3250,
        2983,
        2936,
        3162,
        1433,
        3294,
        1033,
        3373,
        1337,
        1345,
        6275,
        1085,
        3359,
        1338,
        2003,
        1027,
        1340,
        3391,
        3129,
        3295,
        3198,
        478,
        1190,
        825,
        1393,
        2787,
        3968,
        3629,
        2893,
        854,
        3369,
        3609,
        3314,
        1091,
        1015,
        970,
        3075,
        4088,
        1288,
        3130,
        5688,
        5916,
        93,
        666,
        2310,
        3490,
        1508,
        3602,
        3161,
        6683,
        1060,
        2703,
        1945,
        1701,
        4925,
        192,
        1867,
        3120,
        3385,
        2868,
        3505,
        3643,
        2970,
        832,
        1000,
        2910,
        3303,
        1504,
        2446,
        1137,
        1152,
        52,
        787,
        44,
        2984,
        2937,
        3163,
        1434,
        130,
        1086,
        3360,
        1339,
        2004,
        189,
        826,
        853,
        235,
        1016,
        5917
    ],[
        3232,
        3231,
        2177,
        1191,
        767,
        766,
        3501,
        1888,
        768,
        771,
        2482,
        769,
        770,
        3233,
        3502,
        3234,
        1921,
        1030,
        2921,
        3630,
        2922,
        334,
        423,
        473,
        545,
        546,
        549,
        574,
        618,
        619,
        758,
        2527,
        3047,
        117,
        121,
        128,
        3509,
        2531,
        248,
        295,
        3165,
        3621,
        3620,
        3579,
        3361,
        2540,
        317,
        318,
        326,
        352,
        353,
        354,
        398,
        400,
        406,
        407,
        409,
        2100,
        487,
        488,
        515,
        568,
        636,
        146,
        3080,
        691,
        36,
        2528,
        3048,
        3510,
        2532,
        3166,
        35,
        399,
        401,
        33,
        410,
        2138,
        12,
        637,
        3081
    ],[
        3220,
        3548,
        1461,
        2244,
        3178,
        1980,
        3382,
        1487,
        1926,
        1649,
        2920,
        3610,
        2496,
        2550,
        1651,
        1654,
        3252,
        3607,
        1489,
        2247,
        919,
        2647,
        920,
        3618,
        3016,
        2192,
        2248,
        2776,
        322,
        3285,
        2264,
        323,
        1417,
        2293,
        3380,
        819,
        2281,
        2498,
        2622,
        2800,
        2183,
        2955,
        3207,
        3291,
        984,
        3393,
        2467,
        2860,
        2597,
        2174,
        1308,
        6087,
        3337,
        4286,
        335,
        336,
        2228,
        1021,
        6711,
        2232,
        2783,
        6085,
        822,
        3191,
        1241,
        2987,
        2982,
        1454,
        3354,
        1418,
        6684,
        3495,
        1177,
        2668,
        2657,
        2621,
        1410,
        762,
        1412,
        2693,
        730,
        1380,
        922,
        986,
        2271,
        3306,
        2495,
        1904,
        1639,
        3338,
        883,
        2548,
        2274,
        3491,
        5913,
        3296,
        3018,
        3002,
        3507,
        3494,
        3312,
        2504,
        2479,
        3962,
        3157,
        3237,
        2505,
        1291,
        2239,
        731,
        358,
        359,
        1455,
        1077,
        2994,
        2095,
        2537,
        366,
        1289,
        6083,
        3247,
        3176,
        3190,
        6712,
        2088,
        2506,
        3541,
        2627,
        925,
        3372,
        3143,
        1395,
        379,
        2882,
        2885,
        884,
        3144,
        1083,
        3230,
        1907,
        2294,
        3343,
        1399,
        1419,
        3222,
        2906,
        2625,
        3078,
        2249,
        2507,
        1140,
        3550,
        1876,
        1270,
        2097,
        2858,
        2628,
        6089,
        1516,
        1212,
        1908,
        3330,
        736,
        2187,
        2188,
        2862,
        3552,
        3554,
        760,
        2878,
        2598,
        2972,
        1398,
        2698,
        2914,
        3356,
        1396,
        2944,
        309,
        397,
        1923,
        2896,
        2948,
        2991,
        2308,
        2869,
        2664,
        1486,
        3155,
        885,
        1390,
        404,
        2561,
        1413,
        2821,
        1225,
        2781,
        1402,
        2191,
        1894,
        1382,
        927,
        3195,
        3004,
        1491,
        3588,
        3248,
        1297,
        1067,
        1973,
        6151,
        1514,
        3257,
        6082,
        2290,
        817,
        2863,
        2836,
        3346,
        3297,
        2536,
        1941,
        2609,
        3127,
        3293,
        3367,
        2995,
        886,
        1179,
        1113,
        3226,
        1438,
        1428,
        1160,
        3598,
        422,
        2957,
        2851,
        988,
        2935,
        1895,
        2557,
        5529,
        3329,
        1868,
        1481,
        1583,
        2808,
        2242,
        1187,
        2619,
        1070,
        2510,
        1932,
        2240,
        2990,
        2861,
        1881,
        2819,
        85,
        2238,
        2104,
        738,
        3345,
        1507,
        2266,
        3603,
        851,
        777,
        989,
        5687,
        2492,
        844,
        3316,
        3133,
        3574,
        2252,
        3001,
        1451,
        2277,
        2640,
        3482,
        1638,
        931,
        1512,
        2268,
        1112,
        1318,
        1006,
        3332,
        852,
        779,
        1999,
        990,
        3074,
        3308,
        2254,
        2486,
        1966,
        3199,
        3556,
        2256,
        1446,
        3122,
        1483,
        1933,
        810,
        3599,
        2907,
        1571,
        1940,
        3583,
        3595,
        1957,
        5686,
        2996,
        2005,
        1909,
        3378,
        1635,
        1465,
        2257,
        3511,
        3558,
        6152,
        2258,
        2646,
        877,
        4288,
        451,
        1012,
        1920,
        3522,
        2810,
        3182,
        740,
        2235,
        1405,
        3245,
        3353,
        1437,
        2600,
        3520,
        1384,
        1209,
        1034,
        3172,
        3181,
        3050,
        1026,
        3342,
        804,
        3386,
        2942,
        1467,
        2259,
        2555,
        3003,
        3315,
        467,
        2261,
        2891,
        1482,
        2660,
        742,
        1891,
        3061,
        3593,
        3340,
        474,
        1879,
        1960,
        3573,
        1171,
        3586,
        5919,
        476,
        5912,
        3307,
        1493,
        2453,
        2687,
        1150,
        3115,
        2630,
        1953,
        2968,
        2880,
        3508,
        310,
        2241,
        3355,
        1387,
        3560,
        3131,
        1631,
        1404,
        2911,
        1114,
        5794,
        3064,
        1240,
        1153,
        1087,
        3128,
        935,
        1515,
        2897,
        2757,
        936,
        2701,
        1589,
        86,
        3005,
        5275,
        1146,
        1925,
        2329,
        1513,
        3174,
        2641,
        2579,
        3134,
        1424,
        3632,
        1175,
        1028,
        1495,
        812,
        1347,
        2596,
        1928,
        87,
        2993,
        1934,
        2447,
        2180,
        1962,
        2631,
        2632,
        2642,
        784,
        3370,
        3022,
        745,
        2263,
        2534,
        5795,
        2111,
        3590,
        1927,
        1341,
        1409,
        1411,
        3012,
        1144,
        2653,
        5276,
        1122,
        1447,
        3171,
        1154,
        1919,
        511,
        2774,
        2524,
        1117,
        1172,
        2874,
        2469,
        2515,
        1298,
        3138,
        3628,
        1475,
        1937,
        3498,
        3056,
        3228,
        3298,
        1365,
        3066,
        1181,
        3058,
        3060,
        991,
        1107,
        2784,
        2853,
        1556,
        3513,
        3580,
        1637,
        3576,
        3362,
        938,
        1954,
        3335,
        1363,
        3536,
        3532,
        2285,
        2645,
        3194,
        3562,
        1878,
        3619,
        3543,
        1497,
        1930,
        1942,
        942,
        1471,
        3371,
        2567,
        2516,
        5908,
        2227,
        3203,
        3644,
        1469,
        1022,
        3605,
        1031,
        1982,
        3589,
        3547,
        2613,
        3493,
        2517,
        1090,
        2999,
        3483,
        3357,
        1905,
        723,
        3379,
        1258,
        1403,
        2967,
        2298,
        2001,
        1877,
        5328,
        1965,
        2633,
        6278,
        2518,
        2574,
        3196,
        5274,
        1887,
        3251,
        1910,
        1505,
        1870,
        2299,
        2918,
        2519,
        3577,
        2686,
        2554,
        1342,
        6713,
        3309,
        1955,
        3564,
        1105,
        1915,
        3596,
        1035,
        3299,
        1874,
        3540,
        2483,
        1863,
        2520,
        996,
        2566,
        816,
        1935,
        3581,
        2300,
        1969,
        1019,
        2900,
        1420,
        2644,
        3000,
        3925,
        3592,
        1287,
        2952,
        1865,
        788,
        1791,
        1501,
        1296,
        2270,
        579,
        3617,
        3608,
        3964,
        3614,
        3965,
        3615,
        1423,
        2169,
        2559,
        1893,
        3533,
        761,
        2658,
        1301,
        3152,
        1939,
        3389,
        2448,
        2876,
        2926,
        1452,
        1880,
        3639,
        2262,
        3591,
        3966,
        3970,
        2899,
        2623,
        1343,
        1173,
        2276,
        1108,
        3209,
        3020,
        3169,
        3079,
        1875,
        88,
        3528,
        749,
        3242,
        3365,
        1186,
        1139,
        3206,
        1511,
        3594,
        1344,
        2798,
        2292,
        1207,
        1208,
        1407,
        1013,
        2301,
        2472,
        1517,
        1142,
        3566,
        89,
        1169,
        1430,
        2190,
        3506,
        3140,
        3204,
        3014,
        2695,
        1311,
        90,
        2302,
        2265,
        1350,
        2563,
        1017,
        3364,
        2157,
        1038,
        2176,
        1145,
        4289,
        2007,
        6681,
        2634,
        725,
        3606,
        1111,
        2852,
        1902,
        2121,
        1869,
        969,
        1425,
        1155,
        3531,
        850,
        3526,
        1053,
        753,
        2224,
        3145,
        6680,
        1961,
        1036,
        3318,
        1519,
        3584,
        3278,
        270,
        1391,
        5915,
        1575,
        3186,
        2939,
        91,
        3077,
        3600,
        3585,
        1421,
        3065,
        1020,
        3375,
        3135,
        3164,
        1415,
        2883,
        5920,
        1913,
        2950,
        1582,
        2601,
        3601,
        2649,
        3597,
        3612,
        1949,
        887,
        1103,
        3525,
        3363,
        1125,
        2998,
        1561,
        3300,
        3173,
        2283,
        1948,
        3214,
        813,
        2635,
        3153,
        2533,
        2902,
        3381,
        92,
        1950,
        3327,
        639,
        3132,
        3539,
        3537,
        3146,
        2997,
        3287,
        3239,
        3136,
        6279,
        3156,
        277,
        888,
        1484,
        2273,
        2919,
        1167,
        4351,
        1473,
        1946,
        993,
        973,
        756,
        1568,
        823,
        2303,
        3126,
        1168,
        855,
        5689,
        3631,
        2304,
        649,
        650,
        3227,
        2901,
        3073,
        2961,
        2186,
        5909,
        974,
        94,
        994,
        3633,
        653,
        3374,
        3499,
        3641,
        3215,
        95,
        1911,
        1922,
        3578,
        2194,
        2971,
        3521,
        3142,
        2617,
        3147,
        1099,
        2553,
        1592,
        857,
        1916,
        2785,
        1432,
        1562,
        2930,
        3311,
        1422,
        1861,
        6213,
        2932,
        2947,
        1644,
        3213,
        2652,
        1449,
        1092,
        2662,
        2126,
        3368,
        3193,
        1416,
        2526,
        1400,
        3205,
        2980,
        5277,
        3055,
        3334,
        2225,
        1593,
        1889,
        2272,
        1095,
        2778,
        1170,
        2931,
        1406,
        2837,
        3535,
        2945,
        3568,
        2489,
        1450,
        3281,
        2480,
        2127,
        1959,
        3488,
        1378,
        3350,
        3021,
        3546,
        2279,
        1918,
        2692,
        2570,
        1073,
        2985,
        1182,
        1979,
        1156,
        3348,
        3349,
        3486,
        6081,
        3575,
        2541,
        6685,
        1274,
        1394,
        2992,
        1051,
        976,
        1971,
        2543,
        2636,
        1974,
        3582,
        1479,
        2556,
        3341,
        6274,
        1931,
        2688,
        3151,
        2539,
        6090,
        2306,
        2938,
        1110,
        6708,
        3221,
        3549,
        1463,
        3383,
        1488,
        1650,
        3611,
        2497,
        1652,
        1655,
        1490,
        3017,
        2193,
        46,
        3286,
        56,
        820,
        2282,
        2801,
        3208,
        3292,
        3392,
        2468,
        2175,
        6088,
        4287,
        45,
        6086,
        1385,
        2667,
        2656,
        346,
        1381,
        1640,
        2549,
        3492,
        5914,
        3019,
        3313,
        357,
        60,
        54,
        1456,
        2538,
        1290,
        6084,
        3542,
        70,
        3551,
        1269,
        2135,
        2859,
        1213,
        390,
        3553,
        3555,
        2879,
        2973,
        720,
        47,
        1924,
        2949,
        2870,
        2822,
        2782,
        155,
        1383,
        1492,
        3249,
        2291,
        818,
        1180,
        1439,
        1429,
        1161,
        1896,
        2558,
        2809,
        1188,
        2620,
        1069,
        1882,
        2820,
        2142,
        430,
        3604,
        166,
        778,
        2493,
        845,
        2278,
        1007,
        3333,
        174,
        780,
        2000,
        3557,
        811,
        2908,
        1600,
        2006,
        1466,
        3512,
        3559,
        2811,
        3183,
        453,
        3246,
        1210,
        181,
        3051,
        805,
        2943,
        1468,
        472,
        1892,
        695,
        1494,
        3116,
        2881,
        1388,
        3561,
        3284,
        186,
        190,
        1603,
        3006,
        1147,
        2580,
        1176,
        1029,
        1496,
        1348,
        783,
        2181,
        785,
        507,
        2150,
        1123,
        199,
        53,
        2525,
        2875,
        3139,
        1476,
        1938,
        3057,
        3229,
        1362,
        207,
        3336,
        1364,
        3563,
        1498,
        1472,
        1470,
        1032,
        218,
        3484,
        724,
        1259,
        1506,
        3565,
        225,
        1864,
        997,
        1936,
        789,
        1792,
        1502,
        2560,
        3390,
        2449,
        2877,
        2624,
        2275,
        3210,
        3529,
        599,
        3366,
        2799,
        3279,
        3280,
        1518,
        1143,
        3567,
        3141,
        3015,
        2696,
        1351,
        1018,
        2118,
        1037,
        4290,
        2008,
        726,
        1903,
        2160,
        83,
        3527,
        1054,
        622,
        268,
        269,
        271,
        1613,
        3185,
        1614,
        2648,
        1124,
        1615,
        3301,
        2284,
        3137,
        278,
        1485,
        1474,
        1947,
        647,
        856,
        37,
        67,
        5910,
        41,
        3500,
        3148,
        294,
        1917,
        1619,
        1862,
        299,
        2165,
        2981,
        1630,
        1890,
        1096,
        2946,
        3569,
        2166,
        1379,
        2280,
        2986,
        1183,
        1157,
        3067,
        3068,
        3487,
        2542,
        1052,
        2544,
        1480
    ]
]
// export const generalGamesContribution100: string[] = require('../Assets/g100.txt')
// export const generalGamesContribution0: string[] = require('../Assets/g0.txt')
export const GeneralGamesContribution: number[] = [0, 100]
export const generalGamesContribution: number[][] = [
[
2637,
983,
2245,
3232,
1194,
3963,
3538,
3250,
2535,
3613,
1273,
2921,
3630,
2983,
2922,
317,
318,
2445,
3544,
2936,
2956,
326,
3160,
334,
3162,
3317,
1433,
6682,
1059,
3294,
352,
353,
354,
398,
1033,
3373,
400,
406,
407,
3387,
5918,
409,
2100,
1337,
1345,
2702,
891,
1944,
6275,
1085,
3359,
3231,
423,
473,
487,
1700,
1271,
1138,
3388,
1313,
488,
515,
545,
546,
3347,
549,
3497,
3328,
2177,
1338,
1191,
568,
2003,
2639,
1027,
1408,
574,
618,
2509,
2814,
2450,
1340,
2775,
767,
619,
2243,
4924,
2484,
3391,
1151,
636,
1401,
3129,
3295,
3198,
478,
3587,
766,
1190,
2569,
1636,
3485,
1272,
1897,
758,
2527,
3047,
1866,
825,
3616,
1397,
3119,
117,
1393,
2787,
502,
3331,
3968,
3384,
3629,
2893,
3501,
2565,
3344,
121,
1888,
768,
771,
2482,
769,
770,
128,
854,
2002,
3167,
3369,
530,
2867,
3504,
786,
535,
536,
3642,
3609,
2969,
3233,
893,
3314,
3154,
3509,
146,
2531,
3177,
839,
1943,
2643,
3534,
3489,
998,
3080,
1975,
1976,
4285,
248,
2927,
1091,
3967,
295,
1015,
3502,
3165,
3621,
3620,
970,
2978,
3075,
3234,
5911,
3579,
1921,
4088,
1288,
3130,
5688,
5916,
93,
2909,
3361,
1030,
666,
2310,
3490,
2540,
3302,
1508,
3602,
1503,
2984,
2446,
2937,
3161,
691,
3163,
1434,
6683,
1060,
35,
399,
130,
401,
33,
410,
2138,
2703,
1945,
1086,
3360,
36,
12,
1701,
1137,
1339,
2004,
4925,
1152,
637,
189,
192,
2528,
3048,
1867,
826,
3120,
3385,
853,
52,
2868,
3505,
787,
44,
3643,
2970,
3510,
2532,
832,
1000,
3081,
235,
1016,
3166,
5917,
2910,
3303,
1504
]
,
[
3220,
3548,
1461,
2244,
3178,
1980,
3382,
1487,
1926,
1649,
2920,
3610,
2496,
2550,
1651,
1654,
3252,
3607,
1489,
2247,
919,
2647,
920,
3618,
3016,
2192,
2248,
2776,
322,
3285,
2264,
323,
1417,
2293,
3380,
819,
2281,
2498,
2622,
2800,
2183,
2955,
3207,
3291,
984,
3393,
2467,
2860,
2597,
2174,
1308,
6087,
3337,
4286,
335,
336,
2228,
1021,
6711,
2232,
2783,
6085,
822,
3191,
1241,
2987,
2982,
1454,
3354,
1418,
6684,
3495,
1177,
2668,
2657,
2621,
1410,
762,
1412,
2693,
730,
1380,
922,
986,
2271,
3306,
2495,
1904,
1639,
3338,
883,
2548,
2274,
3491,
5913,
3296,
3018,
3002,
3507,
3494,
3312,
2504,
2479,
3962,
3157,
3237,
2505,
1291,
2239,
731,
358,
359,
1455,
1077,
2994,
2095,
2537,
366,
1289,
6083,
3247,
3176,
3190,
6712,
2088,
2506,
3541,
2627,
925,
3372,
3143,
1395,
379,
2882,
2885,
884,
3144,
1083,
3230,
1907,
2294,
3343,
1399,
1419,
3222,
2906,
2625,
3078,
2249,
2507,
1140,
3550,
1876,
1270,
2097,
2858,
2628,
6089,
1516,
1212,
1908,
3330,
736,
2187,
2188,
2862,
3552,
3554,
760,
2878,
2598,
2972,
1398,
2698,
2914,
3356,
1396,
2944,
309,
397,
1923,
2896,
2948,
2991,
2308,
2869,
2664,
1486,
3155,
885,
1390,
404,
2561,
1413,
2821,
1225,
2781,
1402,
2191,
1894,
1382,
927,
3195,
3004,
1491,
3588,
3248,
1297,
1067,
1973,
6151,
1514,
3257,
6082,
2290,
817,
2863,
2836,
3346,
3297,
2536,
1941,
2609,
3127,
3293,
3367,
2995,
886,
1179,
1113,
3226,
1438,
1428,
1160,
3598,
422,
2957,
2851,
988,
2935,
1895,
2557,
5529,
3329,
1868,
1481,
1583,
2808,
2242,
1187,
2619,
1070,
2510,
1932,
2240,
2990,
2861,
1881,
2819,
85,
2238,
2104,
738,
3345,
1507,
2266,
3603,
851,
777,
989,
5687,
2492,
844,
3316,
3133,
3574,
2252,
3001,
1451,
2277,
2640,
3482,
1638,
931,
1512,
2268,
1112,
1318,
1006,
3332,
852,
779,
1999,
990,
3074,
3308,
2254,
2486,
1966,
3199,
3556,
2256,
1446,
3122,
1483,
1933,
810,
3599,
2907,
1571,
1940,
3583,
3595,
1957,
5686,
2996,
2005,
1909,
3378,
1635,
1465,
2257,
3511,
3558,
6152,
2258,
2646,
877,
4288,
451,
1012,
1920,
3522,
2810,
3182,
740,
2235,
1405,
3245,
3353,
1437,
2600,
3520,
1384,
1209,
1034,
3172,
3181,
3050,
1026,
3342,
804,
3386,
2942,
1467,
2259,
2555,
3003,
3315,
467,
2261,
2891,
1482,
2660,
742,
1891,
3061,
3593,
3340,
474,
1879,
1960,
3573,
1171,
3586,
5919,
476,
5912,
3307,
1493,
2453,
2687,
1150,
3115,
2630,
1953,
2968,
2880,
3508,
310,
2241,
3355,
1387,
3560,
3131,
1631,
1404,
2911,
1114,
5794,
3064,
1240,
1153,
1087,
3128,
935,
1515,
2897,
2757,
936,
2701,
1589,
86,
3005,
5275,
1146,
1925,
2329,
1513,
3174,
2641,
2579,
3134,
1424,
3632,
1175,
1028,
1495,
812,
1347,
2596,
1928,
87,
2993,
1934,
2447,
2180,
1962,
2631,
2632,
2642,
784,
3370,
3022,
745,
2263,
2534,
5795,
2111,
3590,
1927,
1341,
1409,
1411,
3012,
1144,
2653,
5276,
1122,
1447,
3171,
1154,
1919,
511,
2774,
2524,
1117,
1172,
2874,
2469,
2515,
1298,
3138,
3628,
1475,
1937,
3498,
3056,
3228,
3298,
1365,
3066,
1181,
3058,
3060,
991,
1107,
2784,
2853,
1556,
3513,
3580,
1637,
3576,
3362,
938,
1954,
3335,
1363,
3536,
3532,
2285,
2645,
3194,
3562,
1878,
3619,
3543,
1497,
1930,
1942,
942,
1471,
3371,
2567,
2516,
5908,
2227,
3203,
3644,
1469,
1022,
3605,
1031,
1982,
3589,
3547,
2613,
3493,
2517,
1090,
2999,
3483,
3357,
1905,
723,
3379,
1258,
1403,
2967,
2298,
2001,
1877,
5328,
1965,
2633,
6278,
2518,
2574,
3196,
5274,
1887,
3251,
1910,
1505,
1870,
2299,
2918,
2519,
3577,
2686,
2554,
1342,
6713,
3309,
1955,
3564,
1105,
1915,
3596,
1035,
3299,
1874,
3540,
2483,
1863,
2520,
996,
2566,
816,
1935,
3581,
2300,
1969,
1019,
2900,
1420,
2644,
3000,
3925,
3592,
1287,
2952,
1865,
788,
1791,
1501,
1296,
2270,
579,
3617,
3608,
3964,
3614,
3965,
3615,
1423,
2169,
2559,
1893,
3533,
761,
2658,
1301,
3152,
1939,
3389,
2448,
2876,
2926,
1452,
1880,
3639,
2262,
3591,
3966,
3970,
2899,
2623,
1343,
1173,
2276,
1108,
3209,
3020,
3169,
3079,
1875,
88,
3528,
749,
3242,
3365,
1186,
1139,
3206,
1511,
3594,
1344,
2798,
2292,
1207,
1208,
1407,
1013,
2301,
2472,
1517,
1142,
3566,
89,
1169,
1430,
2190,
3506,
3140,
3204,
3014,
2695,
1311,
90,
2302,
2265,
1350,
2563,
1017,
3364,
2157,
1038,
2176,
1145,
4289,
2007,
6681,
2634,
725,
3606,
1111,
2852,
1902,
2121,
1869,
969,
1425,
1155,
3531,
850,
3526,
1053,
753,
2224,
3145,
6680,
1961,
1036,
3318,
1519,
3584,
3278,
270,
1391,
5915,
1575,
3186,
2939,
91,
3077,
3600,
3585,
1421,
3065,
1020,
3375,
3135,
3164,
1415,
2883,
5920,
1913,
2950,
1582,
2601,
3601,
2649,
3597,
3612,
1949,
887,
1103,
3525,
3363,
1125,
2998,
1561,
3300,
3173,
2283,
1948,
3214,
813,
2635,
3153,
2533,
2902,
3381,
92,
1950,
3327,
639,
3132,
3539,
3537,
3146,
2997,
3287,
3239,
3136,
6279,
3156,
277,
888,
1484,
2273,
2919,
1167,
4351,
1473,
1946,
993,
973,
756,
1568,
823,
2303,
3126,
1168,
855,
5689,
3631,
2304,
649,
650,
3227,
2901,
3073,
2961,
2186,
5909,
974,
94,
994,
3633,
653,
3374,
3499,
3641,
3215,
95,
1911,
1922,
3578,
2194,
2971,
3521,
3142,
2617,
3147,
1099,
1099,
1592,
857,
1916,
2785,
1432,
1562,
2930,
3311,
1422,
1861,
6213,
2932,
2947,
1644,
3213,
2652,
1449,
1092,
2662,
2126,
3368,
3193,
1416,
2526,
1400,
3205,
2980,
5277,
3055,
3334,
2225,
1593,
1889,
2272,
1095,
2778,
1170,
2931,
1406,
2837,
3535,
2945,
3568,
2489,
1450,
3281,
2480,
2127,
1959,
3488,
1378,
3350,
3021,
3546,
2279,
1918,
2692,
2570,
1073,
2985,
1182,
1979,
1156,
3348,
3349,
3486,
6081,
3575,
2541,
6685,
1274,
1394,
2992,
1051,
976,
1971,
2543,
2636,
1974,
3582,
1479,
2556,
3341,
6274,
1931,
2688,
3151,
2539,
6090,
2306,
2938,
1110,
6708,
3221,
3549,
1463,
3383,
1488,
1650,
3611,
2497,
1652,
1655,
1490,
3017,
2193,
46,
3286,
56,
820,
2282,
2801,
3208,
3292,
3392,
2468,
2175,
6088,
4287,
45,
6086,
1385,
2667,
2656,
346,
1381,
1640,
2549,
3492,
5914,
3019,
3313,
357,
60,
54,
1456,
2538,
1290,
6084,
3542,
70,
3551,
1269,
2135,
2859,
1213,
390,
3553,
3555,
2879,
2973,
720,
47,
1924,
2949,
2870,
2822,
2782,
155,
1383,
1492,
3249,
2291,
818,
1180,
1439,
1429,
1161,
1896,
2558,
2809,
1188,
2620,
1069,
1882,
2820,
2142,
430,
3604,
166,
778,
2493,
845,
2278,
1007,
3333,
174,
780,
2000,
3557,
811,
2908,
1600,
2006,
1466,
3512,
3559,
2811,
3183,
453,
3246,
1210,
181,
3051,
805,
2943,
1468,
472,
1892,
695,
1494,
3116,
2881,
1388,
3561,
3284,
186,
190,
1603,
3006,
1147,
2580,
1176,
1029,
1496,
1348,
783,
2181,
785,
507,
2150,
1123,
199,
53,
2525,
2875,
3139,
1476,
1938,
3057,
3229,
1362,
207,
3336,
1364,
3563,
1498,
1472,
1470,
1032,
218,
3484,
724,
1259,
1506,
3565,
225,
1864,
997,
1936,
789,
1792,
1502,
2560,
3390,
2449,
2877,
2624,
2275,
3210,
3529,
599,
3366,
2799,
3279,
3280,
1518,
1143,
3567,
3141,
3015,
2696,
1351,
1018,
2118,
1037,
4290,
2008,
726,
1903,
2160,
83,
3527,
1054,
622,
268,
269,
271,
1613,
3185,
1614,
2648,
1124,
1615,
3301,
2284,
3137,
278,
1485,
1474,
1947,
647,
856,
37,
67,
5910,
41,
3500,
3148,
294,
1917,
1619,
1862,
299,
2165,
2981,
1630,
1890,
1096,
2946,
3569,
2166,
1379,
2280,
2986,
1183,
1157,
3067,
3068,
3487,
2542,
1052,
2544,
1480
]
]

/*
export const thumbnails: string[] = [
    zeroPng,
    require('../Assets/game-banners/casa-donatella.png'), // donatella
    require('../Assets/game-banners/splashImage5.png'), // mojiooo
    require('../Assets/game-banners/blackjack.jpg'),
    require('../Assets/game-banners/roulette.png'),
    require('../Assets/game-banners/splashImage3.png'), // lost garden
    require('../Assets/game-banners/splashImage4.png'), // pirate queen
    zeroPng, 
    require('../Assets/game-banners/splashImagetoc.png'), // toc
    zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,zeroPng,
    require('../Assets/game-banners/splashImage.png'), // scuba
    require('../Assets/game-banners/splashImage1.png'), // critters
    require('../Assets/game-banners/splashImage2.png'), // fortune god
]
*/
export const SwissTime: string = 'Europe/Zurich'
// export const j: string = require('../Assets/j.png')
export const productName: string[] = ['GaminGenius', '®', ' Admin']
/* Button images */
// export const editButtonImg: string = '../Assets/edit16.png'
// export const delButtonImg: string  = '../Assets/trash16.png'
export const startDateYear: number = 2019
export const startDateMonth: number = 6
export const startDateDay: number = 6
export const nSystem       : number = 1
export const nGameProvider : number = 2
export const nOperator     : number = 3
export const nSite         : number = 4
export const nGameAssetProvider: number = 5
export const nComplianceProvider: number = 6
export const nComplianceSubProvider: number = 7
export const nPaymentProvider: number = 8
export const nPaymentSubProvider: number = 9
export const nAffiliateSite: number = 10
export const nOperator2    : number = 11
export const nSite2        : number = 12
export const nMaster        : number = 13

export const nAdmin        : number = 1
export const nRead         : number = 2
export const nAccount      : number = 3
export const nRiskManager  : number = 4

export const masterAdmin   : number = nMaster * 10 + nAdmin
export const masterRead    : number = nMaster * 10 + nRead

export const systemAdmin   : number = nSystem * 10 + nAdmin
export const systemRead    : number = nSystem * 10 + nRead

export const gameAdmin     : number = nGameProvider * 10 + nAdmin
export const gameRead      : number = nGameProvider * 10 + nRead

export const operatorAdmin  : number = nOperator * 10 + nAdmin
export const operatorSupport: number = nOperator * 10 + nRead
export const operatorAccount: number = nOperator * 10 + nAccount
export const operatorRiskManager: number = nOperator * 10 + nRiskManager

export const siteAdmin: number = nSite * 10 + nAdmin
export const siteRead : number = nSite * 10 + nRead

export const gameAssetAdmin: number = nGameAssetProvider * 10 + nAdmin
export const gameAssetRead : number = nGameAssetProvider * 10 + nRead

export const complianceAdmin: number = nComplianceProvider * 10 + nAdmin
export const complianceRead : number = nComplianceProvider * 10 + nRead

export const complianceSubAdmin: number = nComplianceSubProvider * 10 + nAdmin
export const complianceSubRead : number = nComplianceSubProvider * 10 + nRead

export const paymentAdmin: number = nPaymentProvider * 10 + nAdmin
export const paymentRead : number = nPaymentProvider * 10 + nRead
export const e_mail: string = 'e-mail'
export const paymentSubAdmin: number = nPaymentSubProvider * 10 + nAdmin
export const paymentSubRead : number = nPaymentSubProvider * 10 + nRead
export const SMS: string = 'SMS'
export const affiliateSiteAdmin: number = nAffiliateSite * 10 + nAdmin
export const affiliateSiteRead : number = nAffiliateSite * 10 + nRead
export const PEP: string = 'PEP'
export const operator2Admin  : number = nOperator2 * 10 + nAdmin
export const operator2Support: number = nOperator2 * 10 + nRead
export const operator2Account: number = nOperator2 * 10 + nAccount
export const operator2RiskManager: number = nOperator2 * 10 + nRiskManager
export const CRIF: string = 'CRIF'
export const site2Admin: number = nSite2 * 10 + nAdmin
export const site2Read : number = nSite2 * 10 + nRead
export const VETO: string = 'VETO'
/* FONT AWESOME */
export const faGetPocket: string = 'fa fa-get-pocket'
export const faPowerOffClass: string = 'fa fa-power-off'
export const faCopy: string = 'fa fa-copy'
export const faAlignLeft: string = 'fa fa-align-left'
export const faAlignCenter: string = 'fa fa-align-center'
export const faAlignRight: string = 'fa fa-align-right'
export const faBoldClass: string   = 'fa fa-bold'
export const faTextHeight: string = 'fa fa-text-height'
export const faTextWidth: string = 'fa fa-text-width'
export const faCaretLeft: string = 'fa fa-caret-left'
export const faCaretRight: string = 'fa fa-caret-right'
export const faCaretDown: string = 'fa fa-caret-down'
export const faCaretUp: string = 'fa fa-caret-up'
export const faIdCardOClass: string = 'fa fa-id-card-o'
export const faIdCardClass: string = 'fa fa-id-card'
export const faIdBadgeClass: string = 'fa fa-id-badge'
export const faLightbulbClass: string = 'fa fa-lightbulb-o'
export const faHourglassClass = 'fa fa-hourglass'
export const faHourglassEndClass = 'fa fa-hourglass-end'
export const faHourglassHalfClass = 'fa fa-hourglass-half'
export const faHourglassStartClass = 'fa fa-hourglass-start'
export const faHourglassOClass = 'fa fa-hourglass-o'
export const faStoreClass = 'fa fa-shopping-cart'
export const faLotteryClass = 'fa fa-bomb'
export const faRegisteredClass = 'fa fa-registered'
export const faDeliciousClass = 'fa fa-delicious'
export const faTargetClass = 'fa fa-bullseye'
export const faTargetFwClass = 'fa fa-bullseye fa-fw'
export const faFixedWidth = 'fa fa-fw'
export const faFixedWidthFa = 'fa fa-fw fa-'
const faSort0:string = 'fa fa-sort'
const faSort1:string = 'fa fa-sort-desc'
const faSort2:string = 'fa fa-sort-asc'
export const faSort = [faSort0, faSort1, faSort2]
const Sort0:any = {float:'right', display:'block', marginLeft:'2px', marginTop:'3px', color:'#bbb'}
const Sort1:any = {float:'right', display:'block', marginLeft:'2px', marginTop:'0px'}
const Sort2:any = {float:'right', display:'block', marginLeft:'2px', marginTop:'6px'}
export const faSortStyle = [Sort0, Sort1, Sort2]
export const faMousePointerClass: string = 'fa fa-mouse-pointer'
export const faMousePointerFwClass: string = 'fa fa-fw fa-mouse-pointer'
export const faArrowsClass: string = 'fa fa-arrows'
export const faArrowsAltClass: string = 'fa fa-arrows-alt'
export const faTintClass: string = 'fa fa-tint'
export const faPaintbrushClass: string = 'fa fa-paint-brush'
export const faInfoClass: string = 'fa fa-info'
export const faInfoCircleClass: string = 'fa fa-info-circle'
export const faRewardShopClass:string = 'fa fa-shopping-basket'
export const faProgressClass:string = 'fa fa-bar-chart'
export const faLineClass:string = 'fa fa-line-chart'
export const faStartClass:string = 'fa fa-play fa-fw'
export const faStopClass:string = 'fa fa-stop fa-fw'
export const faStepClass:string = 'fa fa-step-forward fa-fw'
export const faMinusClass: string = 'fa fa-minus'
export const faPlusClass: string = 'fa fa-plus'
export const faUpdateClass: string = 'fa fa-floppy'
export const faImageClass: string = 'fa fa-picture-o'
export const faImageFwClass: string = 'fa fa-picture fa-fw'
export const faPercentageClass: string = 'fa fa-percent'
export const faPercentageFwClass: string = 'fa fa-percent fa-fw'
export const faHamburgerClass: string = 'fa fa-bars'
export const faCopyrightClass: string = 'fa fa-copyright'
export const faDollarButtonClass: string = 'fa fa-dollar'
export const faDollarClass: string       = 'fa fa-dollar fa-fw'


// export const faCurrencyButtonClass: string[] = ['fa fa-dollar','fa fa-euro']
export const faCurrencyButtonClass: string[] = ['fa fa-euro']
export const faQuestionButtonClass: string = 'fa fa-question'
export const faQuestionCircleButtonClass: string = 'fa fa-question-circle fa-lg'
export const faQuestionCircleWhiteButtonClass: string = 'fa fa-question-circle-o fa-lg'
export const faQuestionFwClass: string = 'fa fa-question fa-fw'
export const faPlusButtonClass: string = 'fa fa-plus fa-fw'
export const faMinusButtonClass: string = 'fa fa-minus fa-fw'
export const faPlusSquareClass: string = 'fa fa-plus-square'
export const faMinusSquareClass: string = 'fa fa-minus-square'
export const faDatabaseClass: string = 'fa fa-database-square'
export const faDatabaseButtonClass: string = 'fa fa-database'
// export const faUpdateButtonClass: string = 'fa fa-floppy fa-lg'
export const faEditButtonClass: string = 'fa fa-pencil'
export const faEditLgButtonClass: string = 'fa fa-pencil fa-lg'
export const faCancelButtonClass: string = 'fa fa-times'
export const faCheckButtonClass : string = 'fa fa-check'
export const faTableButtonClass : string = 'fa fa-table'
export const faFa: string = 'fa fa-'
// export const faTableLgButtonClass : string = 'fa fa-table fa-lg'
export const faTrashClass: string = 'fa fa-trash'
export const faTrashLgClass: string = 'fa fa-trash fa-lg'
export const faTrashButtonClass: string = 'fa fa-trash'
export const faTrashLgButtonClass: string = 'fa fa-lg fa-trash'
export const faSearchButtonClass: string = 'fa fa-search'
export const faSearchLgButtonClass: string = 'fa fa-search fa-lg'
export const faPrevButtonClass : string = 'fa fa-arrow-left'
export const faNextButtonClass : string = 'fa fa-arrow-right'
export const faFirstButtonClass: string = 'fa fa-arrow-up'
export const faLastButtonClass : string = 'fa fa-arrow-down'
export const faExternalLinkClass: string = 'fa fa-external-link'
export const faEyeClass: string = 'fa fa-eye'
export const faHiddenClass: string = 'fa fa-eye-slash'
export const faTaskClass: string = 'fa fa-bullseye'
export const faChallengeClass: string = 'fa fa-bolt' // fa-exchange
export const faLinkClass: string = 'fa fa-link'
export const faManyItemsClass: string = 'fa fa-th-large'
export const faOneItemClass: string = 'fa fa-square'
// export const faFirstButtonClass: string = 'fa fa-long-arrow-left'
// export const faLastButtonClass : string = 'fa fa-long-arrow-right'
export const faCompanyClass: string  = 'fa fa-building fa-fw'
/*
export const faSubEntityClass: string  = 'fa fa-building fa-fw'
*/
export const faSubEntityClass: string  = 'fa fa-home fa-fw'
export const faCompanyLgClass: string  = 'fa fa-building fa-fw fa-lg'
export const faSubEntityLgClass: string  = 'fa fa-building fa-fw fa-lg'
export const faMasterClass: string  = 'fa fa-bank fa-fw'
export const faMasterLgClass: string  = 'fa fa-bank fa-fw fa-lg'
export const faUserDark: string      = 'fa fa-user fa-fw'
export const faUserClass: string     = 'fa fa-user fa-fw'
// export const faGiftClass: string     = 'fa fa-gift fa-fw'
export const faUserLgClass: string     = 'fa fa-user fa-lg'
export const faUsernameClass: string = 'fa fa-user fa-fw'
export const faPasswordClass: string = 'fa fa-unlock-alt fa-fw'
export const faLockClass: string = 'fa fa-lock fa-fw'
export const faLanguageClass: string  = 'fa fa-language'
export const faCountryClass: string  = 'fa fa-globe fa-fw'
export const faCountrylgClass: string  = 'fa fa-globe fa-fw fa-lg'
export const faCountryLgClass: string  = 'fa fa-globe fa-fw fa-2x'
export const faAddressClass: string  = 'fa fa-home fa-fw'
export const faPostalClass: string   = 'fa fa-home fa-fw'
export const faCityClass: string     = 'fa fa-home fa-fw'
export const faEmailClass: string    = 'fa fa-envelope fa-fw'
export const faPhoneClass: string    = 'fa fa-phone fa-fw'
export const faRoleClass: string     = 'fa fa-magic fa-fw'
export const faActivityClass: string = 'fa fa-bolt fa-fw'

export const faSiteClass: string     = 'fa fa-sitemap fa-fw'
export const faSite_Class: string     = 'fa fa-sitemap'
/*
export const faSiteClass: string     = 'fa fa-home fa-fw'
export const faSite_Class: string     = 'fa fa-home'
*/
export const faGameClass: string   = 'fa fa-gamepad'
export const faGamingClass: string   = 'fa fa-gamepad fa-fw'
export const faGamingLgClass: string   = 'fa fa-gamepad fa-fw fa-lg'
/*
export const faPaymentClass: string  = 'fa fa-money fa-fw'
export const faBalanceClass: string  = 'fa fa-money fa-fw'
*/
export const faPaymentClass: string  = 'fa fa-credit-card fa-fw'
export const faPaymentClassAlternative: string  = 'fa fa-credit-card-alt fa-fw'
export const faBalanceClass: string  = 'fa fa-credit-card fa-fw'

export const faCommentingClass: string  = 'fa fa-file'
export const faCommentClass: string  = 'fa fa-file fa-fw'
export const faCreditCardClass: string  = 'fa fa-credit-card fa-fw'
export const faCreditCard2Class: string  = 'fa fa-credit-card-alt fa-fw'
export const faFootballClass: string  = 'fa fa-futbol-o fa-fw'
export const facogClass: string      = 'fa fa-cog'
export const faCoGClass: string      = 'fa fa-cog fa-lg'
export const faCogClass: string      = 'fa fa-cog fa-fw'
export const faCogLgClass: string      = 'fa fa-cog fa-fw fa-lg'
export const faCogsClass: string      = 'fa fa-cogs fa-fw'
export const faCogsLgClass: string      = 'fa fa-cogs fa-fw fa-lg'
export const faReportClass: string      = 'fa fa-file fa-fw'
export const faReportLgClass: string      = 'fa fa-file fa-fw fa-lg'
export const faReportCategoryClass: string      = 'fa fa-file fa-fw'
export const faReportCategoryLgClass: string      = 'fa fa-file fa-fw fa-lg'
export const faReportLightClass: string = 'fa fa-file'
export const faLottoClass: string  ='fa fa-level-down'
export const faReportDarkClass: string = 'fa fa-file'
export const faCalendarClass: string = 'fa fa-calendar fa-fw'
export const faCalendarGClass: string= 'fa fa-calendar fa-fw'
export const faCalendar: string= 'fa fa-calendar'
export const faCalendarGLgClass: string= 'fa fa-calendar fa-fw fa-lg'
export const faCalendarRClass:string = 'fa fa-calendar-check fa-fw'
export const faRewardClass: string   = 'fa fa-gift fa-fw'
export const faRewardLgClass: string   = 'fa fa-gift fa-lg fa-fw'
export const faRequireClass: string  = 'fa fa-check-square fa-fw'
export const faRepeatClass: string   = 'fa fa-repeat fa-fw'
export const faTDBClass: string   = 'fa fa-rocket'
export const faRefreshClass: string   = 'fa fa-refresh fa-fw'
export const faPlane: string = 'fa fa-plane'
export const faPaperPlaneO: string = 'fa fa-paper-plane'
export const faPaperPlane: string = 'fa fa-paper-plane'
export const faFighterJet: string = 'fa fa-fighter-jet'
export const faCloneClass: string   = 'fa fa-clone fa-fw'
export const faCancelClass: string   = 'fa fa-times fa-fw'
export const faCheckClass : string   = 'fa fa-check fa-fw'
export const faAchieveClass: string   = 'fa fa-trophy'
export const faAchievementClass: string   = 'fa fa-trophy fa-fw'
export const faLoginClass: string   = 'fa fa-sign-in fa-fw'
export const faTimeClass: string   = 'fa fa-clock-o fa-fw'
// export const faTimeNarrowClass: string   = 'fa fa-clock-o'
export const faTimeNarrowClass: string   = 'fa fa-clock-o'
export const faTimeLgClass: string   = 'fa fa-clock-o fa-fw fa-lg'
export const faTimeLGClass: string   = 'fa fa-clock-o fa-lg'
export const faHashtagClass: string   = 'fa fa-hashtag fa-fw'
export const faCertificateClass: string   = 'fa fa-certificate fa-fw'
export const faPuzzlePieceClass: string   = 'fa fa-puzzle-piece'
export const faPuzzleFixedPieceClass: string   = 'fa fa-puzzle-piece fa-fw'
export const faSelectClass: string   = 'fa fa-asterisk' // arrows
export const faSelectFwClass: string   = 'fa fa-asterisk fa-fw' // arrows
export const faHeightClass: string   = 'fa fa-arrows-v fa-fw'
export const faWidthClass: string   = 'fa fa-arrows-h fa-fw'
export const faFontClass: string   = 'fa fa-font fa-fw'
export const faBorderRadiusClass: string   = 'fa fa-circle-thin fa-fw'
export const faBorderWidthClass: string   = 'fa fa-square fa-fw'
export const faListOlClass: string = 'fa fa-list-ol fa-fw'
export const faListUlClass: string = 'fa fa-list-ul fa-fw'
export const faListClass: string = 'fa fa-list fa-fw'
export const falistClass: string = 'fa fa-list'
export const faListGroupClass: string = 'fa fa-object-group fa-fw'
export const faCircleClass: string = 'fa fa-circle fa-lg'
export const faCircleOClass: string = 'fa fa-circle fa-lg'
export const faCircleLgClass: string = 'fa fa-circle fa-lg fa-fw'
export const faCancelLgClass: string   = 'fa fa-times fa-lg fa-fw'
export const faCasinoClass: string   = 'fa fa-heart'
// export const faThumbsUp: string = 'fa fa-thumbs-o-up'
export const faUserPlus: string = 'fa fa-user-plus'
/* FONT AWESOME END */
export const enum MENU_TYPE { MT_UNDEFINED = 0, MT_GAME_PROGRESS, MT_POINTS_LEVELS, MT_REWARD_SHOP, MT_TOURNAMENT,
    MT_CASINO, MT_ODDS, MT_PROMOTIONS, MT_TOUR_DE_BET, MT_LINK,
    MT_LINK_BETSLIP, MT_LINK_TDB_PREMIUM, MT_LINK_TDB_FREE, MT_FORUM, MT_BLOG, MT_LOTTO}
export const MTI: string[] = [faQuestionButtonClass, faProgressClass, facogClass, faRewardShopClass, faAchieveClass,
        faCasinoClass, faPercentageClass, faImageClass, faTDBClass, faMousePointerClass,
        faMousePointerClass,faMousePointerClass,faMousePointerClass,faCommentingClass, 
        faReportLightClass, faLottoClass]
export const SYSTEM:number = 0
export const MASTER:number = 1
export const CONTRACTUAL_PARTNER:number = 2
export const SUB_ENTITY:number = 3
export const OPERATOR:number = 1
export const GAME_PROVIDER:number = 2
export const PAYMENT_PROVIDER:number = 3
export const COMPLIANCE_PROVIDER:number = 4
export const SITE_OWNER:number = 5
export const _:string = '–||–'
export const spades:string = '♠'
export const clubs:string = '♣'
export const hearts:string = '♥'
export const diamonds:string = '♦'
export const ShowTotalP:string = '%'
export const ShowCumulP:string = '%'
export const enum ATTR {TABLE_GAME = 1, DEPOSIT, ODDS_TYPE, SLOTS, LOGIN, REGISTRATION, WITHDRAWAL}
export const COLOR_WOOD:string = '#966f33'
export const COLOR_AMBER:string = '#ffc200'
export const COLOR_BRONZE:string = '#cd7f32'
export const COLOR_SILVER:string = '#c0c0c0'
export const COLOR_GOLD:string = '#ffd700'
export const COLOR_DIAMOND: string = '#b9f2ff'
export const COLOR_RUBY: string = '#9b111e'
export const COLOR_PLATINUM:string = '#e5e4e2'
export const COLOR_VALHALLA:string = '#337ab7'
export const COLOR_WHITE:string = '#fff'
export const COLOR_TEXT:string = '#333'
export const COLOR_STONE: string = '#727b84'
export const COLOR_IRON: string = '#CBCDCD'
export const COLORS_5: string[] = [COLOR_WOOD, COLOR_STONE, COLOR_AMBER, COLOR_IRON, COLOR_BRONZE, COLOR_SILVER, COLOR_GOLD, COLOR_PLATINUM, COLOR_DIAMOND, COLOR_VALHALLA]
export const COLORS5: string[] = [COLOR_WHITE, COLOR_WHITE, COLOR_TEXT, COLOR_TEXT,COLOR_WHITE, COLOR_TEXT, COLOR_TEXT, COLOR_TEXT, COLOR_TEXT, COLOR_WHITE]

export const COLORS_2: string[] = [COLOR_BRONZE, COLOR_SILVER, COLOR_GOLD, COLOR_RUBY, COLOR_DIAMOND, COLOR_VALHALLA]
export const COLORS2: string[] = [COLOR_WHITE, COLOR_TEXT, COLOR_TEXT, COLOR_WHITE, COLOR_TEXT, COLOR_WHITE]

export const PLAYER_STATS_FIELDS: number = 16
export const PLAYER_STATS_EVENTS: number = 13
export const PLAYER_ID_MAX_LENGTH_DISPLAYED: number = 8
export const PLAYER_ID_LENGTH: number = 36
export interface IMiniGame {
    id: number
    rewards: number[]
}

export const Annual: string[] = ['2017', '2018', '2019']
export const enum TOURNAMENT_TYPE {SportsBookCasino = 1, SportsBook, Casino, LottoBet, Custom}

export const SELECT_ALL: number = 99998
export const DESELECT_ALL: number = 99999

export const ImageLeft: number = 0

export const ImageRightScandibet: number = 1
export const ComingSoonScandibet: number = 2

export const ImageLeftMobile: number = 1
export const ImageRight: number = 2
export const ComingSoon: number = 3

export enum RewardIntent {
    Generic,
    Missions,
    Levels,
    Tournaments,
    Challenges,
    Store,
    Minigame,
 }

export const RewardIntentIcons: string[] = [faSelectClass, faTargetClass, faCogClass, faAchieveClass, faChallengeClass, faStoreClass, faGamingClass]

export const ChristmasDecorations: Array<{id: string, name: string}> = [
    {id:'0', name: 'Lights'},
    {id:'1', name: 'Snowflake'},
    {id:'2', name: 'Christmas Tree'},
    {id:'3', name: 'Gifts'},
    {id:'4', name: 'Snowflakes'},
    {id:'5', name: 'Stars'},
    {id:'6', name: 'Christmas Tree 2'},
    {id:'7', name: 'Lights 2'},
    {id:'8', name: 'Christmas Ball'},
    {id:'9', name: 'Christmas Ball 2'},
    {id:'10', name: 'Christmas Tree 3'},
    {id:'11', name: 'Lights 3'},
    {id:'12', name: 'Lights 4'},
    {id:'13', name: 'Lights 5'},
    {id:'14', name: 'Merry X-mas'},
    {id:'15', name: 'Christmas Balls'},
    {id:'16', name: 'Snowflake 2'},
    {id:'17', name: 'Gift 1'},
    {id:'18', name: 'Gift 2'},
    {id:'19', name: 'Christmas Cap'},
    {id:'20', name: 'Gift Cat'},
    {id:'21', name: 'Christmas Tree 4'},
    {id:'22', name: 'Christmas Tree 5'},
    {id:'23', name: 'Christmas Tree 6'},
    {id:'24', name: 'Rudolf'},
    {id:'25', name: 'Gift Cat 2'},
    {id:'26', name: 'Christmas Tree 7'},
    {id:'27', name: 'Santa'},
    {id:'28', name: 'Santa 2'},
    {id:'29', name: 'Santa 3'},
    {id:'30', name: 'Santa 4'},
    {id:'31', name: 'Happy New Year'},
    {id:'32', name: 'Merry Christmas'},
    {id:'33', name: 'New Year\'s Eve'},
    {id:'34', name: 'Fireworks'},
    {id:'35', name: 'Fireworks 2'},
    {id:'36', name: 'Fireworks 3'},
    {id:'37', name: '2018-2019'},
    {id:'38', name: 'Snowflake 3'},
    {id:'39', name: 'Snowflake 4'},
    {id:'40', name: 'Snowflake 5'},
    {id:'41', name: 'Snowflake 6'},
    {id:'42', name: 'Snowflake 7'},
    {id:'43', name: 'Snowflake 8'},
    {id:'44', name: 'Christmas Coffee'},
    {id:'45', name: 'Snowflakes 2'},
    {id:'46', name: 'Freezing Cold'},
    {id:'47', name: 'Damn it\'s Cold'},
    {id:'48', name: 'So Cold'},
    {id:'49', name: 'Gifts 2'},
    {id:'50', name: 'Gift Cat 3'}, 
]

export const PastImages: Array<{id: string, name: string}> = [
    {id:'0', name: 'No past image'},
    {id:'1', name: '20% cashback'},
    {id:'2', name: '25% bonus'},
    {id:'3', name: '50% bonus'},
    {id:'4', name: '50% live casino bonus'},
    {id:'5', name: '100% bonus'},
    {id:'6', name: 'Free spins'},
    {id:'7', name: 'Mega spins'},
    {id:'8', name: 'Riddle'},
    {id:'9', name: 'Super spins'},
    {id:'10', name: 'Unlimited bonus'},
    {id:'11', name: 'Unlimited free spins'},
]
// tslint:disable-next-line:max-line-length
// const colors: string[] = ['white', 'gray','silver','black','maroon','red','purple','fuchsia','green','lime','olive','yellow','navy','blue','teal','aqua','orange','indianred','lightcoral','salmon','darksalmon','lightsalmon','crimson','firebrick','darkred','pink','lightpink','hotpink','deeppink','mediumvioletred','palevioletred','coral','tomato','orangered','darkorange','gold','lightyellow','lemonchiffon','lightgoldenrodyellow','papayawhip','moccasin','peachpuff','palegoldenrod','khaki','darkkhaki','lavender','thistle','plum','violet','orchid','magenta','mediumorchid','mediumpurple','blueviolet','darkviolet','darkorchid','darkmagenta','indigo','slateblue','darkslateblue','mediumslateblue','greenyellow','chartreuse','lawngreen','limegreen','palegreen','lightgreen','mediumspringgreen','springgreen','mediumseagreen','seagreen','forestgreen','darkgreen','yellowgreen','olivedrab','darkolivegreen','mediumaquamarine','darkseagreen','lightseagreen','darkcyan','cyan','lightcyan','paleturquoise','aquamarine','turquoise','mediumturquoise','darkturquoise','cadetblue','steelblue','lightsteelblue','powderblue','lightblue','skyblue','lightskyblue','deepskyblue','dodgerblue','cornflowerblue','royalblue','mediumblue','darkblue','midnightblue','cornsilk','blanchedalmond','bisque','navajowhite','wheat','burlywood','tan','rosybrown','sandybrown','goldenrod','darkgoldenrod','peru','chocolate','saddlebrown','sienna','brown','snow','honeydew','mintcream','azure','aliceblue','ghostwhite','whitesmoke','seashell','beige','oldlace','floralwhite','ivory','antiquewhite','linen','lavenderblush','mistyrose','gainsboro','lightgrey','darkgray','dimgray','lightslategray','slategray','darkslategray']
// tslint:disable-next-line:max-line-length
export interface IConditions {
    currencies?: ICurrencies[]
    rewardId?: number
    minRounds?: number
    bigWinValue?: number
}
export interface ICurrencies {
    code: string
    minBet?: string
    maxBet?: string
}

export const LTH: string[] = ['th-center', 'th-left', 'th-left', 'th-center']
export const PositionsColors: string[] = ['#005487', '#196593', '#33769f', '#4c87ab', '#ddd']
export const securityQuestions: Array<{id: string, name: string}> = [
    {id:'0', name: 'No security question!'},
    {id:'1', name: 'What is your mother\'s maiden name?'},
    {id:'2', name: 'Which phone number do you remember most from your childhood?'},
    {id:'3', name: 'What was your favorite place to visit as a child?'},
    {id:'4', name: 'Who is your favorite actor, musician, or artist?'},
    {id:'5', name: 'What is the name of your favorite pet?'},
    {id:'6', name: 'In what city were you born?'},
    {id:'7', name: 'What high school did you attend?'},
    {id:'8', name: 'What is the name of your first school?'},
    {id:'9', name: 'What is your favorite movie?'},
    {id:'10', name: 'What is the first and last name of your first boyfriend or girlfriend?'},
    {id:'11', name: 'What was the make of your first car?'},
    {id:'12', name: 'When is your anniversary?'},
    {id:'13', name: 'What is the name of your first grade teacher?'},
    {id:'14', name: 'What was your high school mascot?'},
    {id:'15', name: 'What is the name of your first pet?'},
]
export const RiskManagementGroups: string[] = [
    /* TemporaryAccountStatus, NoPlayerActivity, LargeValueDeposit, LargeValueWithdrawal, BlacklistCheck, MaximumAmountOnPlayerWallet,  */ RiskManagementIssues, InternalPlayerRisk,
]
export const KnowYourCustomerGroups: string[] = [
    ProvisionalAccountStatus, NoPlayerActivity, LargeDeposits, LargeWithdrawals, MaximumAmountOnPlayerWallet, KnowYourCustomerIssues,
]
export const ResponsibleGamingGroups: string[] = [
    NetLimitLoss, NetLimitLossRegistration, TemporaryExclude, ResponsibleGamingIssues, PermanentExclusion, SelfAssessment, DashboardBackend, BlacklistCheck,
]
export const RGDashboardGroups: string[] = [
    DepositMethods, DepositAfterCoolOff, CancelledWithdrawals, GamingTime, HigherNetLoss, InitiatedCoolOffs, IncreasedNetLoss,
]
export const PlayerCardButtons: string[] = [
    PlayerTimeline,
    Transactions,
    // PlayingSessions,
    GameSessions,
    RiskManagement,
    ResponsibleGaming,
    KnowYourCustomer,
    Gamification,
    Promotions,
    GiftShop,
    Tournaments,
]
export const UserInfoButtons: string[] = [
    General,
    Rewards,
    Chances,
    Tournaments + _and_ + Races
]
export const SWIFT: string = 'SWIFT'
export const BIC: string = 'BIC'
export const jackpotschLevelColor: string[] = ['#fff', '#c90227', '#C0C0C0', '#FFD700', '#b9f2ff', '#000']
export const jackpotschLevelText: string[] = ['#000', '#fff', '#000', '#000', '#000', '#fff']
export const jackpotsAccountStatusColor: string[] = ['#007bff','#17a2b8','#20c997','#28a745','#dc3545','#e83e8c','#343a40','#6c757d','#000']
export const t00_12:string = '00:00 - 12:00'
export const t12_24:string = '12:00 - 24:00'
export const t00_06:string = '00:00 - 06:00'
export const t06_12:string = '06:00 - 12:00'
export const t12_18:string = '12:00 - 18:00'
export const t18_24:string = '18:00 - 24:00'
export const t00_03:string = '00:00 - 03:00'
export const t03_06:string = '03:00 - 06:00'
export const t06_09:string = '06:00 - 09:00'
export const t09_12:string = '09:00 - 12:00'
export const t12_15:string = '12:00 - 15:00'
export const t15_18:string = '15:00 - 18:00'
export const t18_21:string = '18:00 - 21:00'
export const t21_24:string = '21:00 - 24:00'
export const IBAN: string = 'IBAN'
export const GaminGeniusBusinessReport:string = 'GaminGenius® Business Report'
export const lightYellow:string = '#FFFACD'
export const lightBlue:string = '#dfffff'
export const lightGreen:string = '#abdda4'
export const darkGreen:string = '#668462'
export const selectedOrange:string = '#FC8D59'
export const dataGrey100:string = '#000'
export const dataGrey75:string = '#333'
export const dataGrey50:string = '#666'
export const dataGrey25:string = '#999'
export const dataGrey0:string =  '#ddd'
export const borderGrey:string = '#fff'
export const backgroundGrey:string = '#f3f3f3'
export const reactDatesGrey:string = '#757575'
export const reactDatesGreyColor:string = 'reactDatesGrey'
export const dateDisplayFormat:string = 'YYYY-MM-DD'
export const dateDisplayFormatdmy:string = 'DD-MM-YYYY'
export const dateDisplayFormatMonthYear:string = 'MMMM/YYYY'
export const dateDisplayFormatWeekDMY:string = '[Week] WW, DD-MM-YYYY'
export const dateDisplayFormatDayDMY:string = 'ddd, DD-MM-YYYY'
export const _js: string = '.js'
export const _min: string = '.min'
export const jpg: string = 'jpg'
export const _jpg: string = '.' + jpg
export const png: string = 'png'
export const _png: string = '.' + png
export const gif: string = 'gif'
export const _gif: string = '.' + gif
export const csv: string = 'csv'
export const _csv: string = '.' + csv
export const xml: string = 'xml'
export const _xml: string = '.' + xml
export const txt: string = 'txt'
export const _txt: string = '.' + txt
export const tempJpg: string = 'temp.jpg'
export const temp_jpg: string = 'temp1.jpg'
export const UTC: string = 'UTC'
export const NA: string = 'N/A'
export const Uncategorized: string = 'Uncategorized'
export const sum: string = 'Σ'
export const NoDataReturnedFromTheQuery: string = 'No data returned from the query.'
export const FailedToGetRecentTransactions: string = 'Failed to get recent transactions.'
export const FailedToFetchPlayerCard: string = 'Failed to fetch player card.'
export const ParameterPlayerIdMustBeSpecified: string = 'Parameter playerId must be specified.'
export const PDF: string = 'PDF'
export const pdf: string = 'pdf'
export const back: string = 'back'
export const front: string = 'front'
export const CSV: string = 'CSV'
export const GDPR: string = 'GDPR'
export const SecurityRights: string[] = [Administrator, Support, Operator, Marketing, RFSpecialist, RGSpecialist, GDPR, Accounting, Reports, GamanzaAdministrator, GamanzaGamesAdministrator, GamanzaMagicHand]
export const XP: string = 'XP'
export const CLONED: string = 'CLONED'
export const customCloseIcon: JSX.Element = <i className = {faCancelButtonClass + ' ' + reactDatesGreyColor}/>
export const customArrowIcon: JSX.Element =  <i className = {faNextButtonClass + ' ' + reactDatesGreyColor}/>
export function strapi(color: string, fontSize: number, top?: number, left?: number): JSX.Element {
    return (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        // ariaHidden={true}
        focusable="false"
        width="0.95em"
        height="1em"
        style={{position: top !== undefined && left !== undefined ? 'absolute' : 'static', top: top !== undefined ? top + 'px' : '', left: left !== undefined ? left + 'px' : '', fontSize: fontSize + 'px'/*, msTransform: 'rotate(360deg)', WebkitTransform: 'rotate(360deg)', transform: 'rotate(360deg)'*/}}
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 256 271"
    >
        <path d="M116.553 0L0 67.953v30.143l49.665 29.786 41.701-22.719V78.74l88.299-50.706 62.046 35.736-.074 71.452-85.07 49.009-28.485-10.537-37.917 24.188.963 57.903 26.105 15.073 117.51-66.961V163.65l-13.212 7.111v25.586l-104.264 59.114-12.915-7.456-.708-42.525 24.47-16.352 29.493 10.53L256 142.912l-.935-87.256-75.387-43.023L78.016 71.009v26.41L49.824 112.41 13.35 90.536V75.622l102.893-59.986 21.598 13.763 13.049-7.513L116.553 0zm69.517 71.092l-21.882 13.276.556 25.588 22.438 12.312 21.882-13.276-.556-25.587-22.438-12.313zm.25 11.559l12.303 6.75.305 14.03-11.997 7.278-12.302-6.75-.305-14.03 11.997-7.278zM73.702 141.024l-2.963-5.614a2.527 2.527 0 0 0-3.414-1.055l-19.393 10.23A2.527 2.527 0 0 0 46.876 148l2.964 5.618a2.526 2.526 0 0 0 3.414 1.055l19.391-10.234a2.528 2.528 0 0 0 1.056-3.415m11.216 17.046l-2.962-5.616a2.527 2.527 0 0 0-3.511-1.003L45.74 170.572a2.528 2.528 0 0 0-.96 3.361l2.962 5.616a2.528 2.528 0 0 0 3.51 1.003l32.706-19.12a2.528 2.528 0 0 0 .959-3.362m3.053 11.536l-38.447 22.1a2.525 2.525 0 0 0-.976 3.37l2.964 5.615a2.527 2.527 0 0 0 3.493 1.012l38.449-22.1a2.527 2.527 0 0 0 .975-3.371l-2.963-5.615a2.528 2.528 0 0 0-3.495-1.011" fill={color}/>
    </svg>
    )
}

export function clover(color: string, fontSize: number, top?: number, left?: number): JSX.Element {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            // width="1184.000000pt"
            // height="1280.000000pt"
            height="1em"
            width="0.925em"
            viewBox="0 0 1184.000000 1280.000000"
            preserveAspectRatio="xMidYMid meet"
            style={{position: top !== undefined && left !== undefined ? 'absolute' : 'static', top: top !== undefined ? top + 'px' : '', left: left !== undefined ? left + 'px' : '', fontSize: fontSize + 'px'/*, msTransform: 'rotate(360deg)', WebkitTransform: 'rotate(360deg)', transform: 'rotate(360deg)'*/}}
        >

            <metadata>
            Created by potrace 1.15, written by Peter Selinger 2001-2017
            </metadata>
            <g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
            fill="#000000" stroke="none">
            <path d="M7950 12790 c-210 -27 -330 -64 -545 -170 -343 -169 -682 -430 -905
            -698 -122 -145 -332 -458 -404 -600 -50 -99 -75 -248 -115 -692 -21 -227 -30
            -346 -76 -985 -44 -606 -74 -907 -94 -942 -16 -29 -51 225 -151 1087 -143
            1235 -180 1446 -310 1751 -194 452 -646 828 -1215 1010 -285 91 -517 93 -827
            8 -270 -75 -500 -198 -756 -408 -230 -188 -359 -326 -658 -701 -281 -352 -440
            -568 -499 -677 -20 -38 -40 -59 -69 -74 -50 -26 -69 -41 -316 -243 -275 -226
            -393 -330 -505 -448 -232 -244 -354 -444 -433 -713 -53 -180 -66 -279 -66
            -500 1 -270 31 -470 91 -589 51 -103 235 -321 361 -429 196 -168 617 -389 926
            -487 406 -128 797 -191 1671 -270 707 -64 972 -96 1044 -126 l34 -14 -34 -36
            c-42 -43 -93 -59 -259 -78 -178 -21 -418 -34 -870 -46 -832 -22 -1189 -50
            -1450 -115 -349 -87 -799 -393 -1060 -720 -274 -345 -380 -653 -435 -1265 -20
            -216 -20 -421 0 -486 27 -92 177 -316 393 -587 157 -196 274 -319 455 -476
            l172 -150 89 -191 c49 -105 111 -230 138 -278 163 -285 438 -646 651 -855 201
            -197 341 -278 599 -346 349 -93 886 -133 1119 -83 267 56 602 251 851 494 112
            109 228 276 323 467 117 235 210 619 340 1416 96 582 156 903 195 1028 39 125
            97 183 204 203 l38 7 -6 -84 c-8 -110 -42 -850 -57 -1239 -13 -329 -7 -855 11
            -1010 44 -385 182 -844 375 -1248 141 -294 260 -460 499 -697 186 -185 294
            -269 446 -345 118 -59 211 -89 412 -130 175 -37 180 -36 198 29 5 20 19 88 31
            151 28 152 22 209 -33 320 -38 78 -56 100 -230 273 -305 305 -387 412 -508
            662 -278 573 -383 1042 -435 1940 -26 439 -20 812 15 970 20 94 21 95 42 35
            104 -302 179 -574 267 -975 121 -543 146 -608 359 -912 291 -416 515 -662 832
            -913 279 -221 483 -322 767 -379 374 -75 650 -40 953 121 159 85 255 154 322
            231 34 39 100 103 147 143 185 152 255 256 496 733 176 347 340 597 544 827
            102 116 161 164 294 244 l110 65 47 90 c26 50 72 133 104 185 93 155 136 287
            181 554 42 253 59 454 59 701 -1 281 -9 320 -118 540 -230 463 -513 726 -976
            908 -228 89 -430 141 -665 171 -304 39 -387 41 -1500 41 -618 0 -1096 4 -1104
            9 -11 7 -11 10 1 17 32 18 260 47 883 114 823 89 1043 126 1310 225 430 158
            752 331 1090 585 383 288 574 547 690 936 78 258 135 648 135 909 -1 209 -27
            317 -130 525 -149 300 -306 475 -587 657 -79 51 -258 168 -397 260 -360 236
            -454 330 -722 718 -152 222 -254 353 -366 477 -264 290 -593 489 -918 554
            -111 23 -394 33 -510 19z" fill={color}/>
            </g>
        </svg>
    )
}

export const ageGroup: AgeGroup[] = [
    {high: 24, text: '≤24'},
    {low: 25, high: 34, text: '25-34'},
    {low: 35, high: 44, text: '35-44'},
    {low: 45, high: 54, text: '45-54'},
    {low: 55, high: 64, text: '55-64'},
    {low: 65, text: '≥65'},
]
export const QuartersMonthly: string[] = ['Q1', 'Q1', 'Q1', 'Q2', 'Q2', 'Q2', 'Q3', 'Q3', 'Q3', 'Q4', 'Q4', 'Q4']
export const QuartersSingular: string[] = ['Q1', 'Q2', 'Q3', 'Q4']
export const StatisticsYearStart: number = 2019
export const StatisticsQuarterStart: number = 0
export const StatisticsMonthStart: number = 0
export const currency: string = 'CHF'
export const kilobytesShort: string = 'kB'
export const XML: string = 'XML'
export const TimeUnits: Array<'Year'|'Month'|'Week'|'Day'|'Hour'|'Minute'|'Second'> = ['Year', 'Month', 'Week', 'Day', 'Hour', 'Minute', 'Second']

export const gamanzaGameIntegrationErrors: Array<{status: number, message: string}> = [
    {status: 8100, message: 'Invalid Transaction type'},
    {status: 8101, message: 'Invalid input/Bad request'},
    {status: 8102, message: 'Authentication Error'},
    {status: 8103, message: 'Invalid Game Session Id',},
    {status: 8104, message: 'Invalid Auth token',},
    {status: 8105, message: 'Auth token already used',},
    {status: 8106, message: 'Invalid GameId',},
    {status: 8107, message: 'Invalid Currency',},
    {status: 8108, message: 'Invalid PlayerId',},
    {status: 8109, message: 'Invalid LanguageCode',},
    {status: 8110, message: 'Player does not have enough money',},
    {status: 8111, message: 'Invalid Amount',},
    {status: 8112, message: 'Invalid transactionId',},
    {status: 8113, message: 'Invalid roundId',},
    {status: 8114, message: 'Round already closed',},
    {status: 8115, message: 'Bet does not exist',},
    {status: 8116, message: 'Duplicate transaction Id',},
    {status: 8117, message: 'Duplicate Round Id',},
    {status: 8118, message: 'Duplicate Game Session Id',},
    {status: 8119, message: 'Account locked',},
    {status: 8120, message: 'User blocked',},
    {status: 8121, message: 'Transaction already cancelled',},
    {status: 8122, message: 'Session ended',},
    {status: 8123, message: 'Playing time limit exceeded',},
    {status: 8124, message: 'NetLoss limit exceeded',},
    {status: 8125, message: 'Wager limit exceeded',},
    {status: 8126, message: 'Deposit limit exceeded',},
    {status: 8127, message: 'Property transactionId must be specified'},
    {status: 8128, message: 'Duplicate id'},
    {status: 8129, message: 'Expired token'},
    {status: 8130, message: 'Transaction does not exist'},
    {status: 8131, message: 'Invalid refId'},
    {status: 8132, message: 'Duplicate refId'},
    {status: 8133, message: 'Property gameId must be specified'},
    {status: 8134, message: 'Property gameSessionId must be specified'},
    {status: 8135, message: 'Property roundId must be specified'},
    {status: 8136, message: 'Property wagerTransactionId must be specified'},
    {status: 8137, message: 'Invalid property wagerTransactionId'},
    {status: 8138, message: 'Session expired'},
    {status: 8139, message: 'Invalid token'},
    {status: 8210, message: 'Property game must be specified'},
    {status: 8220, message: 'Property games must be specified'},
    {status: 8230, message: 'Property game.gameId must be specified'},
    {status: 8240, message: 'Property categories must be specified'},
    {status: 8250, message: 'Property category must be specified'},
    {status: 8260, message: 'Property category.id must be specified'},
    {status: 8270, message: 'Property id must be specified'},
    {status: 8280, message: 'Property labels must be specified'},
    {status: 8290, message: 'Property label must be specified'},
    {status: 8300, message: 'Property label.id must be specified'},
    {status: 8310, message: 'Property gameSuppliers must be specified'},
    {status: 8320, message: 'Property gameSupplier must be specified'},
    {status: 8330, message: 'Property gameSupplier.id must be specified'},
    {status: 8340, message: 'Property gameProvider must be specified'},
    {status: 8350, message: 'Property gameProvider.id must be specified'},
    {status: 8360, message: 'Property jurisdictions must be specified'},
    {status: 8370, message: 'Property jurisdiction must be specified'},
    {status: 8380, message: 'Property jurisdictions.id must be specified'}
]
/*
export const games: string =
`|#Luxurylife|
3220
3221
|100 Joker Staxx: 100 lines|
3548
3549
|108 Heroes Multiplier Fortunes|
1461
1463
|12 Animals|
2244
|12 Zodiacs|
2637
|1429 Uncharted Seas|
983
|15 Golden Eggs|
2245
|1st Down Slot|
3178
|2 Hand Casino Holdem|
3232
|3 Elements|
1980
|3 Fruits Win: 10 lines|
3382
3383
|3 Genie Wishes|
1487
1488
|3 Hit Pay|
1926
|3 Kingdoms - Battle of Red Cliffs|
1649
1650
|300 Shields|
1194
|300 Shields Extreme|
3963
|3888 Ways of the Dragon|
2920
|40 Finest XXL|
3610
3611
|40 Joker Staxx|
2496
2497
|5 Lions|
2550
|5 Lions Gold|
3538
|5 Lucky Lions|
3250
|7 Monkeys|
1651
1652
|7 Piggies|
1654
1655
|777 Gems|
3252
|7's to Burn|
3607
|8 Dragons|
1489
1490
|88 Dragon|
2535
|88 Fortunes|
3613
|88 Wild Dragon|
2247
|A Dragon's Story|
919
|A la Carte|
2647
|A While on the Nile|
920
|Absolute Super Reels|
1273
|Blackjack First Person|
2921
|Dream Catcher First Person|
3630
|Action Bank|
3618
|Action Ops: Snow & Sable|
3016
3017
|Adelia the Fortune Wielder|
2192
2193
|African Spirit|
2248
|Age of Caesar|
2776
|Age of Dragons|
2983
2984
|Agent Jane Blonde|
322
46
|Agent Jane Blonde Returns|
3285
3286
|Aladdin's Legacy|
2264
|Alaskan Fishing|
323
56
|Alchymedes|
1417
|Alice Adventure|
2293
|Lightning Roulette First Person|
2922
|Almighty Sparta|
3380
|Aloha! Cluster Pays|
819
820
|Amazing Aztecs|
2281
2282
|Amazon Fierce|
2498
|Ambiance|
2622
|Aces and Eights|
317
|Aces and Faces|
318
|Anaconda Eye Rapids|
2800
2801
|Ancient Egypt|
2183
|Ancient Egypt Classic|
2955
|Ancient Fortunes: Zeus|
3207
3208
|Ancient Troy|
3291
3292
|Arabian Nights TM|
2445
2446
|Arcader|
984
|Arcane: Reel Chaos|
3393
3392
|Archangels: Salvation|
2467
2468
|Ark of Mystery|
2860
|Asgard|
2597
|Asgardian Stones|
2174
2175
|Astro Cat|
1308
|Astro Cat Deluxe|
3544
|Astro Legends: Lyra and Erion|
2936
2937
|Astro Pandas|
2956
|All American|
326
|Atlantic Wilds|
6087
6088
|Atlantis Thunder|
3160
3161
|Atlants|
3337
|Aura of Jupiter|
4286
4287
|Avalon|
335
45
|Avalon II- Quest for The Grail|
336
|Aztec Gems|
2228
|Babushkas|
1021
|Aztec Palace|
6711
|Baby Bloomers|
2232
|Atlantic City Blackjack Gold|
334
691
|Bachelorette Party|
2783
|Back to the Fruits|
6085
6086
|Bangkok Dreams|
3162
3163
|Bar Bar Blacksheep|
822
1385
|Bar X Hot Spins +|
3191
|Barbershop Uncut|
1241
|Barnyard Twister|
2987
|Baron Samedi|
2982
|Basic Instinct|
3317
|Battlestar Galactica|
1454
|Bear Money|
3354
|Beautiful Bones|
1433
1434
|Beauty and the Beast|
1418
|Bar-X Safecracker Megaways|
6684
|Beavis and Butthead|
3495
|Beetle Jewels|
1177
|Imperial Riches|
6682
6683
|Berryburst|
2668
2667
|Berryburst MAX|
2657
2656
|Best Things in Life|
2621
|Best Witch|
1059
1060
|Bicicleta|
1410
|Big 500 Slot|
3294
|Big Bad Wolf|
762
|Big Blox|
1412
|Big Bot Crew|
2693
|Big Kahuna|
730
346
|Bikini Party|
1380
1381
|Bingo Billions|
922
|Birds On A Wire|
986
|Birthday!|
2271
|Blackbeard|
3306
|Bonus Deuces Wild|
352
35
|Bonus Poker|
353
|Bonus Poker Deluxe|
354
|Deuces and Joker|
398
399
|Blaze of Ra|
2495
|Blood Queen|
1904
|Blood Suckers|
1033
130
|Blood Suckers II|
1639
1640
|Bloodpact|
3338
|Bloopers|
883
|Bollywood Story|
2548
2549
|Bonanza|
3373
|Deuces Wild|
400
401
|Double Bonus Poker|
406
|Double Double Bonus|
407
33
|Book of Gods|
2274
|Book of Gold Classic|
3491
3492
|Book of Gold Double Chance|
|5913_x000D_
|
5914
|Book of Immortals|
3296
|Book of Oz|
3018
3019
|Book of Sun|
3002
|Book of Sun Multichance|
3507
|Book of the Irish|
3494
|Books & Pearls|
3312
3313
|Boom Bang!|
2504
|Boomerang Bonanza|
2479
|Booming Circus|
3962
|Boomshakalaka|
3157
|Boost It|
3237
|Boost Racers|
2505
|Booster|
1291
|Bork The Berzerker|
2239
|Break Away|
731
357
|Break Da Bank|
358
60
|Break Da Bank Again|
359
54
|Bridesmaids|
1455
1456
|Bucaneers Bay|
1077
|Buffalo Rising Megaways|
2994
|Burlesque Queen|
2095
|Burning Wins: classic 5 lines|
2537
2538
|Bust The Bank|
366
|Butterfly Staxx|
1289
1290
|Butterfly Staxx 2|
6083
6084
|Caishen’s Cash|
3387
|Caribbean Anne|
5918
|Carnaval Forever|
3247
|Carnival Queen|
3176
|Cash Bug|
3190
|Egyptian King|
6712
|Cash Camel|
2088
|Cash Of Lords|
2506
|Cash-o-Matic|
3541
3542
|Double Joker (flash)|
409
410
|Double Joker Power|
2100
2138
|Casino Win Spin|
2627
|Casinomeister|
925
|Castle Builder|
1337
|Castle Builder II|
1345
|Caveman Bob|
3372
|Cazino Cosmos|
3143
|Cazino Zeppelin|
1395
|Centre Court|
379
70
|Centurion|
2882
|Centurion Freespins|
2885
|Champion's Goal|
884
|Champions of Rome|
3144
|Charms and Witches|
1083
|Cheeky Monkeys|
3230
|Cherry Blast|
1907
|Cherry Trio|
2294
|Chi|
3343
|Chibeasties|
1399
|Chibeasties 2|
1419
|Chicago Gangsters|
2702
2703
|Chicken Fox|
3222
|Chief!|
2906
|Chilli Chilli Bang Bang|
2625
|Chilli Gold 2 - Stellar Jackpots|
891
|Chilli Heat|
1944
1945
|Chillipop|
3078
|Christmas Charm|
2249
|Cirtakus|
2507
|Classic 243|
1140
|Claws vs Paws|
3550
3551
|Cleo's Wish|
1876
|Cloud Tales|
1270
1269
|Clover Tales|
2097
2135
|Coins of Egypt|
2858
2859
|Coins Of Fortune|
2628
|Colossal Gems|
6275
|Colossal Vikings|
6089
|Cool Bananas|
1516
|Copy Cats|
1212
1213
|Cosmic Crystals|
1908
|Crazy Bananas|
3330
|Cricket Star|
736
390
|Crypbattle|
2187
|Crypcrusade|
2188
|Crystal Clans|
2862
|Crystal Crush|
3552
3553
|Crystal Land|
3554
3555
|Crystal Queen|
760
|Crystal Rift|
2878
2879
|Cuba Caliente|
2598
|Cutie Cat|
2972
2973
|Cyrus The Virus|
1398
|Da Vinci's Treasure|
2698
|Dalai Panda|
2914
|Danger! High Voltage|
3356
|Dark Joker Rizes|
1396
|Dark Vortex|
2944
|Dazzle Me|
309
720
|Dead or Alive|
1085
1086
|Dead or Alive 2|
3359
3360
|deal or no deal|
3231
|Deck The Halls|
397
47
|Deco Diamonds|
1923
1924
|Demon Gems|
2896
|European Blackjack Gold|
423
36
|HiLo 13 European Blackjack Gold|
473
|Jacks or Better|
487
12
|Dia De Los Muertos|
2948
2949
|Diamond Mine Megaways|
2991
|Diamond Strike|
1700
1701
|Diamond Wild|
1271
|Diego Fortune|
2308
|Dino Odyssey|
2869
2870
|Disco Bar 7s|
2664
|Disco Double|
1486
|Divine Dreams|
3155
|Divine Fortune|
1138
1137
|DJ Wild|
885
|Doctor Electro|
3388
|Dolphin Gold|
1390
|Dolphin Gold with stellar jackpot|
1313
|Dolphin Quest|
404
|Donuts|
2561
|Jacks or Better 4 Play Power Poker|
488
|Louisiana Double|
515
|Double Dragons|
1413
|Double Joker|
2821
2822
|Multi - Hand Blackjack|
545
|Multi Hand - Atlantic City Blackjack|
546
|Double Play Superbet|
1225
|Double Stacks|
2781
2782
|Doubles|
1402
|Doublin Gold|
2191
|Dr Fortuno|
3347
|Multi-hand European Blackjack Gold|
549
|Dracula|
1894
155
|Dragon Chase Rapid|
3497
|Dragon Dance|
1382
1383
|Dragon Drop|
927
|Dragon Horn|
3195
|Dragon Hunter|
3004
|Dragon Kingdom|
1491
1492
|Dragon Legend|
3588
|Dragon of the Princess|
3248
3249
|Dragon Palace|
1297
|Dragon Pearls|
3328
|Dragon Shrine|
1067
|Dragon Sisters|
1973
|Dragon Stone|
6151
|Dragon Tiger|
2177
|Dragon Wins|
1514
|Dragons' Awakening|
3257
|Dragons Lucky 8|
6082
|Dragon's Myth|
1338
1339
|Dream Catcher|
1191
|Poker Pursuit|
568
|Dream Date|
2290
2291
|Drive|
817
818
|Duck Shooter|
2863
|DungeonQuest|
2836
|Durian Dynamite|
3346
|Dwarf Mine|
3297
|Dwarfs Gone Wild|
2536
|Easter Island|
1941
|Eastern Emeralds|
2609
|Ecuador Gold|
3127
|Egg Spendables|
3293
|Eggomatic|
2003
2004
|Egyptian Dreams|
2639
|Egyptian Fortunes|
3367
|Egyptian Rise|
1027
|El Jackpotto|
2995
|Electric Sam|
886
|Elements|
1179
1180
|Emerald Isle|
1113
|Emerald Smash|
3226
|emojiplanet|
1438
1439
|EmotiCoins|
1428
1429
|Emperor of the Sea|
1160
1161
|Emperor's Favour|
3598
|Empire Fortune|
1408
|Enchanted Woods|
422
|Epic Joker|
2957
|Erik the Red|
2851
|Esqueleto Explosivo|
988
|Premier Roulette|
574
|Spanish 21 Blackjack|
618
|Ever After|
2935
|Excalibur|
1895
1896
|Exotic Cats|
2557
2558
|Extra Chilli|
5529
|Extra Juicy|
3329
|Eye of the Amulet|
1868
|Fairy Gate|
1481
|Fairy Tale|
1583
|Fairytale Forest Quik|
2808
2809
|Fairytale Fortune|
2242
|Fairytale Legends: Hansel and Gretel|
1187
1188
|Fairytale Legends: Mirror Mirror|
2619
2620
|Fairytale Legends: Red Riding Hood|
1070
1069
|Fakir Slot|
2509
|Fancy Fruits Red Hot Fire Pot|
2814
|Farah’s Adventure|
2510
|Fat Cat|
1932
|Fat Rabbit|
2240
|Fat Santa|
2990
|Feng Shui Kitties|
2861
|Finn and the Swirly Spin|
1881
1882
|Fire 88's|
2450
|Fire eagle|
2819
2820
|Firestorm|
85
|Fireworks Fever|
2238
|Fireworks Master|
2104
2142
|Fish Party|
738
430
|Fishin' Frenzy Megaways|
3345
|Five Pirates|
1507
|Flame|
2266
|Flower Fortunes Megaways|
3603
3604
|Flowers|
851
166
|Flowers Christmas Edition|
777
778
|Flux|
989
|Football Favourites|
5687
|Football Superstar|
2492
2493
|Football: Champions Cup|
844
845
|Forest Mania|
3316
|Forsaken Kingdom|
1340
|Fortune Diamond|
3133
|Fortune Dogs|
2775
|Fortune Gods|
3574
|Fortune Multiplier|
2252
|Fortunes Of Sparta|
3001
|Fortunes of the Dead|
1451
|Fortunium|
2277
2278
|Four Divine Beasts|
2640
|Foxin Twins|
3482
|Foxin Wins|
1638
|Foxin' Wins Again|
931
|Foxin Wins Christmas Edition|
1512
|Foxin' Wins Football Fever|
2268
|free bet blackjack|
767
|Spanish 21 Blackjack Gold|
619
|Frog Grog|
1112
|Frogs n Flies|
1318
|Frozen Diamonds|
1006
1007
|Fruit Case TM|
3332
3333
|Fruit Shop|
852
174
|Fruit Shop Christmas Edition|
779
780
|Fruit Spin|
1999
2000
|Fruit Warp|
990
|Fruit Zen|
3074
|Fruitbat Crazy|
3308
|Fruiterra Fortune|
2254
|Fruitoids|
2486
|Fruit-o-Matic 96|
1966
|Fruits|
3199
|Fruits & Jokers: 100 lines|
3556
3557
|Fruity Wild|
2256
|FruitZ|
1446
|Fu Cai Shen|
3122
|Full Moon Romance|
1483
|Funky Chicken|
1933
|Game of Thrones (243 Ways)|
810
811
|Ganesha Gold|
3599
|Gates of Babylon|
2907
2908
|Geisha|
1571
1600
|Gem Rocks|
1940
|Gem Saviour|
3583
|Gem Saviour Sword|
3595
|Gems of the Gods|
1957
|Genie Jackpots Cave of Wonders|
5686
|Genie Jackpots Megaways|
2996
|Ghost Pirates|
2005
2006
|Gifts of Ostara|
1909
|Gladiators Go Wild|
3378
|Glorious Empire|
1635
|Gnome Wood|
1465
1466
|Gnomes' Gems|
2257
|Go Bananas TM|
3511
3512
|God of Wild Sea|
3558
3559
|Goddess of the Moon|
2243
|Gods of Olympus Megaways|
6152
|Gods Temple|
2258
|God's Temple Deluxe|
2646
|GOLD|
877
|Gold Canyon|
4288
|Gold Factory|
451
|Gold Lab|
1012
|Gold Rush|
1920
|Gold Vein|
3522
|Golden Dunes|
2810
2811
|Golden Egg of Crazy Chicken|
3182
3183
|Golden Era|
740
453
|Golden Farm|
2235
|Golden Fishtank|
1405
|Golden Grimoire|
3245
3246
|Golden Lucky Pigs|
3353
|Golden Mane|
1437
|Golden Royals|
2600
|Golden Tiger|
3520
|Goldilocks|
1384
|Goldwyns Fairies|
1209
1210
|Gonzo's Quest|
1034
181
|Goodfeathers|
3172
|Gorilla Go Wilder|
3181
|Grand Spinn|
4924
4925
|Great Rhino|
2484
|Great Warrior|
3050
3051
|Great Wild Elk|
1026
|Grizzly Gold|
3342
|Guns N' Roses Video Slots|
804
805
|Gunslinger: Fully Loaded|
3391
|Hall of Gods|
1151
1152
|Hall of the Mountain King|
3386
|Halloween Jack|
2942
2943
|Halloween Online Slot|
1467
1468
|Halloween Witch|
2259
|Hanzo's Dojo|
2555
|Happiest Christmas Tree|
3003
|Happy Birds|
3315
|Hellboy|
467
|Hell's Band|
2261
|Henry VIII|
2891
|Hidden|
1482
|Hidden Valley|
2660
|High Society|
742
472
|Highlander|
1891
1892
|Highway To Hell|
3061
|Tens or Better|
636
637
|Hip Hop Panda|
3593
|Hit it Big|
3340
|HitMan|
474
695
|Ho Ho Tower|
1879
|Hockey Hero|
1960
|Holmes & The Stolen Stones|
1401
|Holy Diver|
3129
|Honey Trap of Diao Chan|
3573
|Hong Bao|
3295
|Hong Kong Tower|
1171
|Hood vs Wolf|
3586
|Hot 4 Cash|
5919
|Hot as Hades|
476
|Hot Chilli|
5912
|Hot Fever 2|
3307
|Hot Hot Fruit|
3198
|Hot Ink|
478
|Hot Safari|
1493
1494
|Hot Shots|
2453
|Hot Spin|
2687
|Hot Sync|
1150
|Hotline|
3115
3116
|HotNudge|
2630
|Hotpot|
3587
|Humpty Dumpty|
1953
|Ice Ice Yeti|
2968
|Icy Gems|
2880
2881
|Ignite the Night|
3508
|Illuminous|
310
|Illusions 2|
2241
|immersive roulette|
766
|Immortal Guild|
3355
|Immortal Romance|
1387
1388
|Imperial Fruits|
3560
3561
|Imperial Wealth|
3131
|In Jazz|
1631
3284
|Incinerator|
1404
|Infinite Blackjack|
767
|Inspector Gadget|
2911
|Irish Eyes 2|
1114
|Irish Frenzy|
5794
|Ivan and the Immortal King|
3064
|Ivanhoe|
1240
|Jack and the beanstalk|
1153
186
|Jack Hammer|
1087
190
|Jack Hammer 2|
1190
189
|Jackaroo Jack|
3128
|Jackpot Jester 200000|
2569
|Jackpot Jester 50k|
1636
|Jackpot Raiders|
3485
|Jackpot Rango|
1272
|Jackpot6000|
1897
192
|Jack's Beanstalk|
935
|Vegas Strip Blackjack Gold|
758
|American Roulette TM|
2527
2528
|Baccarat|
3047
3048
|Jade Idol|
1515
|Jaguar Gems|
2897
|Jaguar Temple|
2757
|James Dean|
936
|Jammin jars|
2701
|Jetsetter|
1589
1603
|Jewel Blast|
86
|Jewel Quest Riches|
1866
1867
|Jimi Hendrix Online Slot TM|
825
826
|Jin Ji Bao Xi: Endless Treasure|
3616
|Jingle Spin|
3005
3006
|John Hunter and the Aztec Treasures|
5275
|Joker Millions|
1397
|Joker Pro|
1146
1147
|Joker Stacks|
1925
|Joker Strike|
2329
|Joker Supreme|
3119
3120
|Blackjack|
117
|Jokerizer|
1393
|Jolly's Gifts|
1513
|Journey Of The Gods|
3174
|Jugglenaut|
2641
|Jumanji|
2579
2580
|Jumbo Stampede|
3134
|Jump!|
2787
|Jungle Books|
1424
|Jungle Delight|
3632
|Jungle Spirit: Call of the Wild|
1175
1176
|JungleJim ElDorado|
1028
1029
|Jurassic Giants|
1495
1496
|Jurassic Park|
812
|Jurassic World|
1347
1348
|Just a Game|
2596
|Kaiju|
1928
|King Cashalot|
502
|King Colossus|
87
|King Kong Cash|
2993
|King Kong Fury|
1934
|King of Kings|
3331
|King of Slots TM|
2447
783
|Kingdom of the Sun: Golden Age|
2180
2181
|Kingmaker|
3968
|Kiss of Luck 96|
1962
|KitchenDramaBbqFrenzy|
2631
|KitchenDramaSushiMania|
2632
|Koi Gate|
2642
|Koi Princess|
784
785
|Kokeshi|
3370
|La Bomba|
3022
|Ladies Nite|
745
507
|Lake's Five|
2263
|Lara Croft: Temples and Tombs|
3384
3385
|Larry the Leprechaun|
3629
|Lava Loca|
2534
|Leaders of the Free Spin World|
2893
|Legacy of Ra Megaways|
5795
|Legend of Cleopatra|
2111
2150
|Legend of Hou Yi|
3590
|Legend of Loki|
1927
|Legend of Olympus|
1341
|Legend of The Golden Monkey|
1409
|Legend of the White Snake Lady|
1411
|Leprechaun Carol|
3012
|Leprechaun Hills|
1144
|Leprechaun Song|
2653
|Leprechaun's Lucky Barrel|
5276
|Life of Riches|
1122
1123
|Lightning Dice|
3501
|Lightning Gems|
1447
|Lightning Horseman|
2565
|Lightning Leopard|
3344
|lightning roulette|
766
|Blackjack Classic Touch|
121
|Lightning Strike Megaways|
3171
|Lights|
1154
199
|Little Panda|
1919
|Live American Roulette|
1888
|Live Baccarat|
768
|Live Blackjack|
767
|Live Caribbean Stud Poker|
771
|Live Football Studio|
2482
|Live Holdem|
769
|Live Roulette|
766
|Live Three Card Poker|
770
|Loaded HD|
511
53
|London Hunters|
2774
|Lost Relics|
2524
2525
|Lost Vegas|
1117
|Blackjack Touch - Single Deck|
128
|Lucha Dora|
1172
|Lucha Legends|
2874
2875
|Lucha Maniacs|
2469
|Luck Ness|
2515
|Lucky Angler|
854
853
|Lucky Bakery|
1298
|Lucky Firecracker|
3138
3139
|Lucky Fish|
3628
|Lucky Links|
1475
1476
|Lucky Little Gods|
1937
1938
|Lucky Lucky|
3498
|Lucky New Year|
2002
|Lucky Staxx: 40 lines|
3056
3057
|Lucky Streak 3|
3228
3229
|Lucky Stripes|
3298
|Lucky Twins|
1365
1362
|Lucky Xmas|
3066
|Machina|
3167
|Magic Oak|
3369
|Magic Portals|
1181
207
|Magic Stars 3|
3058
|Magic Target Deluxe|
3060
|Magicious|
991
|Major Millions|
530
52
|Mammoth Chase|
2867
2868
|Manic Millions|
1107
|Master Chen's Fortune|
2784
|Mayan Ritual|
2853
|Mayana|
1556
|MayanMagic|
3513
|Medusa 1|
3580
|Medusa 2|
1637
|Medusa 2|
3576
|Medusa Megaways|
3362
|Medusa NYX|
938
|Meet the Meerkats|
1954
|Mega Burning Wins|
3335
3336
|Mega Fortune|
786
787
|Mega Joker|
3504
3505
|Mega Money Multiplier|
1363
1364
|Mega Moolah|
535
44
|Mega Moolah Isis|
536
|Mercy of the Gods|
3642
3643
|Merlin's Magic Mirror|
3536
|Merlins Money Burst|
3532
|Mexico Wins|
2285
|Miami Nights|
2645
|Midas Golden Touch|
3194
|Midas Treasure|
3609
|Mighty Africa|
3562
3563
|Mighty Arthur|
1878
|Mighty Black Knight|
3619
|Mighty Hot Wilds|
3543
|Mighty Kong|
1497
1498
|Mild Rockers|
1930
|Million Coins Respins|
1942
|Miss Midas|
942
|Moby Dick|
1471
1472
|Moe Moe Cuisine ver. China|
3371
|Moirai Blaze|
2567
|Mojo Spin|
2516
|Money Train|
5908
|Monkey God|
2969
2970
|Monkey Madness|
2227
|Monkey Money|
3203
|Monkey Warrior|
3644
|monopoly live|
3233
|Monster Wheels|
1469
1470
|Monster Wins|
1022
|Montezuma|
3605
|More Monkeys - Stellar Jackpots|
893
|Motorhead Video Slot|
1031
1032
|Mount Mazuma|
3314
|Mr Illusio|
1982
|Mr. Hallow-Win|
3589
|Mr. Vegas|
3154
|Casino Hold'em|
3509
3510
|Deuces Wild Double Up|
146
|French Roulette TM|
2531
2532
|Mustang Gold|
3177
|Mystery of Eldorado|
3547
|Mystery of LongWei|
2613
|Mystery Spin Deluxe Megaways|
3493
|Mystic Charm|
2517
|Mythic Maiden|
1090
218
|Napoleon|
2999
|Narcos|
3483
3484
|Neo Tokyo|
3357
|Neon Jungle|
1905
|Neon Reels|
839
832
|Neon Staxx|
723
724
|Niagara Falls|
3379
|Ninja Chef|
1258
1259
|Nirvana|
1403
|Nitro Circus|
2967
|Nord's War|
2298
|Northern Sky|
2001
|Not Enough Kittens|
1877
|Nuwa|
5328
|Ocean's Secret 96|
1965
|Oktoberfest|
2633
|Olympian Gods|
6278
|Olympus Evolution|
2518
|Olympus Thunder|
2574
|Onmyoji|
3196
|Opal Fruits|
5274
|Orient Express|
1887
|Owls|
3251
|Ozwin's Jackpots|
1943
|Paint|
1910
|Panda Panda|
2643
|Panther Queen|
1505
1506
|Paranormal Activity|
1870
|Patrick's Pub|
2299
|Pearl of the Orient|
2918
|Pearl Tracker|
2519
|Peas Fairy|
3577
|Peking Luck|
2686
|Penguin City|
2554
|Penguin Splash|
1342
|Casino on the House|
6713
|Perfect Catch|
3309
|Peter and the Lost Boys|
1955
|Phoenix Fire|
3564
3565
|Phoenix Sun|
1105
|Pied Piper|
1915
|Piggy Gold|
3596
|Piggy Riches|
1035
225
|Pinata Bucks|
3534
|Pinata Fiesta|
3299
|Pink Elephants|
1874
|Pirate Booty|
3540
|Pirate Gold|
3489
|Pirates' Charm|
2483
|Planet of the Apes|
1863
1864
|Plasma Fusion|
2520
|Platoon|
996
997
|Platoon Wild|
998
1000
|Platooners|
2566
|Playboy|
816
|Playboy Gold|
1935
1936
|Plushie Frenzy|
3581
|Poisoned Apple|
2300
|Jacks Or Better Double Up TM|
3080
3081
|Polar Picnic 96|
1969
|Poltava|
1019
|Polterheist|
2900
|Power Force Heroes|
1975
|Power Force Villains|
1976
|Power Plant|
1420
|Powerspin|
4285
|Roulette Touch|
248
|Presto|
2644
|Primal Megaways|
3000
|Prime Zone|
3925
|Prosperity Lion|
3592
|Prosperity Twin|
1287
|Pumpkin Patch|
2952
|Pumpkin Smash|
1865
|Pyramid: Quest for Immortality|
788
789
|Queen of Atlantis|
1791
1792
|Queen of Gold|
1501
1502
|Queen of Riches|
1296
|Queen of the Castle|
2270
|Rabbit in the Hat|
579
|Raging Rhino|
3617
|Raging Rhino Megaways|
3608
|Rainbow Cash Pots|
3964
|Rainbow Riches|
3614
|Rainbow Riches Megaways|
3965
|Rainbow Riches Pick n Mix|
3615
|Rainbow Ryan|
1423
|Rainbow Wilds|
2169
|Rainbrew|
2559
2560
|Rambo|
2927
|Rapunzel's Tower|
1893
|Raven's Eye|
3533
|Razortooth|
761
|Red Dragon Wild|
2658
|Red Roo|
1301
|Red Temple II|
3152
|Reef Run|
1939
|Reel Rush|
1091
235
|Reel Splitter|
3389
3390
|Reel Steal TM|
2448
2449
|Reel Talent|
2876
2877
|Relic Heroes|
2926
|Renegades|
1452
|Reptoids|
1880
|Respin Circus|
3639
|Respin Rhino|
2262
|Restaurant Craze|
3591
|Return of Kong Megaways|
3966
|Richie in Vegas|
3967
|Riders of the Storm|
3970
|Rise of Anubis|
2899
|Rise of Egypt|
2623
2624
|River of Riches|
1343
|Roasty McFry and the Flame Busters|
1173
|Robin of Sherwood|
2276
2275
|Robo Smash|
1108
|Rockabilly Wolves|
3209
3210
|Rocket Fellas|
3020
|Rome: Rise of an Empire|
3169
|Rook's Revenge	|
3079
|Txs Holdem Pro|
295
|Route 777|
1875
|Royal Frog|
88
|Ruby Casino Queen|
3528
3529
|Rugby Star|
749
599
|Safari King|
3242
|Sakura Dragon|
3365
3366
|Sakura Fortune|
1186
|Sam on the Beach|
1139
|Samurai Girl|
3206
|Samurai Split|
1511
|Santa's Gift Rush|
3594
|Scary Friends|
1344
|Sceptre of Cleo|
2798
2799
|Scrolls of RA|
2292
|Scruffy Duck|
1207
1208
|Scudamore's Super Stakes|
1208
3280
|Seasons|
1407
|Second Strike|
1013
|Secret Of Nefertiti|
2301
|Secret of Nefertiti 2|
2472
|Secret of the Stones|
1517
1518
|Secret Romance|
1142
1143
|Secrets of Atlantis|
1015
1016
|Sevens & Fruits|
3566
3567
|Sevens High|
89
|Shangri-La|
1169
|Shaolin Spin|
1430
|She Ninja Suzu|
2190
|Shiba Inu|
3506
|Shogun of Time|
3140
3141
|Show me the Mummy|
3204
|Showdown Saloon|
3014
3015
|Side Bet City|
3502
|Side Winder|
2695
2696
|Silver Lion|
1311
|Sinbad|
90
|Singles Day|
2302
|Siren's Kingdom|
2265
|Six Acrobats|
1350
1351
|Si-Xiang|
2563
|Skulls of Legend|
1017
1018
|Sky Gems 5 Wilds|
3364
|SkyWay|
2157
2118
|Slammin 7s|
1038
1037
|Smile|
2176
|Snowflakes|
1145
|Solar Queen|
4289
4290
|Casino Barbut|
3165
3166
|Space Wars|
2007
2008
|Pixies Vs Pirates|
6681
|SpaceArcade|
2634
|American Blackjack|
3621
|European Blackjack|
3620
|Sparks|
725
726
|Spartacus|
3606
|Spectra|
1111
|Spectrum|
2852
|speed roulette|
766
|Spellcast|
1902
1903
|Spellcraft|
2121
2160
|Spin or Reels|
1869
|Spin Sorceress|
969
|Spina Colada|
1425
|Spinata Grande|
1155
83
|Spinfinity Man|
3531
|Spinions Beach Party|
850
|Spinsane|
3526
3527
|Spooky Family|
1053
1054
|Spring Break|
753
622
|Stacks O'Gold|
2224
|Stampede|
3145
|Razor Shark|
6680
|Star Fall|
1961
|Starburst|
1036
268
|Starmania|
970
|Starstruck|
3318
|Steam Tower|
1519
269
|Steampunk|
3584
|Stellar Jackpot with Silver Lion|
2978
|Stellar Spins|
3278
|Stickers|
270
271
|Sticky Bandits|
1391
|Sticky Bandits: Wild Return|
5915
|Stone Age|
1575
1613
|Strolling Staxx: Cubic Fruit|
3186
3185
|Sugar Pop|
3075
|Sugar Skulls|
2939
|Sugar Trail|
91
|SugarPop 2: Double Dipped|
3077
|Sumi-e|
3600
|Summon & Conquer|
3585
|Sunny Shores|
1421
|Sunset|
3065
|Sunset Delight|
1020
|Super Boom|
3375
|Super Diamond Wild|
3135
|Super Fruits Joker|
3164
|Super Heroes|
1415
|Super Hot Fruits|
2883
|Super Lucky Charms|
5920
|super sic bo|
3234
|Super Sumo|
1913
|Supreme Fortune|
2950
|Surfin' Reels|
5911
|Sushi|
1582
1614
|Sushicade|
2601
|Sweet Bonanza|
3601
|Swipe & Roll|
2649
2648
|Symbols of Egypt|
3597
|Sync Reels|
3612
|Taboo|
1949
|Taco Brothers|
887
|Taco Brothers Saving Christmas|
1103
|Tahiti Gold|
3525
|Tales of Dr. Do Little|
3363
|Tarzan|
1125
1124
|Ted|
2998
|Temple Cats|
1561
1615
|Temple of Nudges|
3300
3301
|Temple of Treasures Megaways|
3173
|Temple of Tut|
2283
2284
|Temple Quest Spinfinity|
1948
|Temple Tumble Megaways|
3214
|Joker Wild|
3579
|Terminator 2|
813
|TeslaJolt|
2635
|Texas Hold'em Bonus Poker|
1921
|TexCoCo|
3153
|The Champions|
2533
|The Creepy Carnival|
4088
|The Curious Cabinet|
2902
|The Dog House|
3381
|The Epic Journey|
92
|The Falcon Huntress|
1950
|The Final Countdown|
3327
|The Finer Reels of Life|
639
|The Fortune Pig|
3132
|The Golden Chase|
3539
|The Golden City|
3537
|The Golden Owl Of Athena|
3146
|The Goonies|
2997
|The Grand|
3287
|The Grand National Race of Champions|
3239
|The Great Albini|
3136
3137
|The Great Chicken Escape|
6279
|The Great Pigsby|
3156
|The Invisible Man|
277
278
|The Lab|
888
|The Legend of Shangri-La: Cluster Pays|
1484
1485
|The Lost Riches of Amazon|
1288
|The Love Guru|
3130
|The Mask|
2273
|The Nutcracker|
2919
|The Odd Forest|
1167
|The One Armed Bandit|
4351
|The Phantom of the Opera|
1473
1474
|The Phantom's Curse|
1946
1947
|The Rift|
993
|The Shadow Order|
5688
|The Spin Lab|
973
|The Twisted Circus|
756
647
|The Vampires|
1568
|The Wild Chase|
823
|The Wish Master|
5916
5917
|The Witch|
2303
|The Wiz|
3126
|Theatre of Night|
1168
|Theme Park: Tickets of Fortune|
855
856
|Thor: Hammer Time|
5689
|Three Monkeys|
3631
|Three musketeers|
93
|Thunder Zeus|
2304
|Thunderstruck|
649
37
|Thunderstruck II|
650
67
|Ticket to the Stars|
3227
|Tiger Claws|
2909
2910
|Tiger Rush|
2901
|Tiger's Claw|
3073
|Tigers Glory|
2961
|Tiki Tumble|
2186
|Tiki Vikings|
5909
5910
|Titan Storm|
974
|Titan Thunder|
94
|Toki Time|
994
|Tomb of Treasure|
3633
|Tomb Raider|
653
41
|Tombstone|
3374
|Tower of Power|
3499
3500
|TractorBeam|
3641
|Treasure Horse|
3215
|Treasure Island|
95
|Treasures of Horus|
1911
|Tree of Fortune|
1922
|Tree of Fortune (PG Soft)|
3578
|Tribe|
2194
|Triple Dragons|
2971
|Triple Jokers|
3521
|Trolls Bridge|
3142
|Turn It Up|
2617
|Turn Your Fortune|
3147
3148
|Turning Totems|
1099
|Tut's Twister|
2553
|Twerk|
1592
|Twin Spin|
857
294
|Twin Spin Deluxe|
1916
1917
|Dr Fortuno Blackjack|
3361
|Ukiyo-e|
2785
|Ultimate Dream Team|
1432
|Ultimate Texas Holdem|
1030
|Undine's Deep|
1562
1619
|Untamed Giant Panda|
666
|Valkyrie|
2930
|Valletta Megaways|
3311
|Valley of the Gods|
1422
|Vampire: The Masquerade|
1861
1862
|Vampires vs Wolves|
6213
|Van Gogh|
2310
|Vegas Diamonds|
2932
|Vegas High Roller|
3490
|Vegas Magic|
2947
|Vegas Nights|
1644
|Vegas Reels II|
3213
|Sonya Blackjack|
2540
|Vegas VIP Gold|
2652
|Venice Magic|
1449
|Victorious|
1092
299
|Viking Clash|
2662
|Viking Gods: Thor and Loki|
2126
2165
|Viking Voyage|
3368
|Viking Wilds|
3193
|Vikings Fortune: Hold and Win|
3302
3303
|Vikings Go Berzerk|
1416
|Vikings Go To Hell|
2526
|Vikings Go Wild|
1400
|Vikings Unleashed Megaways|
3205
|Vikings Video Slot|
2980
2981
|Vikings Winter|
5277
|VIP Filthy Riches|
3055
|Volcano Eruption Extreme|
3334
|Volcano Riches|
2225
|Voodoo|
1593
1630
|Wacky Panda|
1889
1890
|Wai kiki|
2272
|Warlords - Crystals of Power|
1095
1096
|Ways of Fortune|
2778
|Well of Wonders|
1170
|White Rabbit|
1508
|Who Wants to be a Millionaire|
2931
|Wicked Circus|
1406
|Wild 888|
2837
|Wild Ape|
3535
|Wild Bazaar|
2945
2946
|Wild Burning Wins: 5 lines|
3568
3569
|Wild Diamond 7x|
2489
|Wild Dodo|
1450
|Wild Gladiator|
3281
|Wild Heist at Peacock Manor|
2480
|Wild Hunter|
2127
2166
|Wild Neon|
1959
|Wild Ocean|
3488
|Wild Orient|
1378
1379
|Wild Pixies|
3350
|Wild Plunder|
3021
|Wild Robo Factory|
3546
|Wild Scarabs|
2279
2280
|Wild Seas|
1918
|Wild Sumo|
2692
|Wild Swarm|
2570
|Wild Toro|
1073
|Wild Trucks|
3602
|Wild Warriors|
2985
2986
|Wild Water|
1182
1183
|Wild Wheel|
1979
|Wild Wild West: The Great Train Heist|
1156
1157
|Wild Worlds|
3348
3349
|Wild-O-Tron 3000|
3349
3068
|Win Blaster|
3486
3487
|Win Win|
6081
|Win Win Won|
3575
|Winners Cup|
2541
2542
|Wild Tome of the Woods|
6685
|Wins of Fortune|
1274
|Winterberries|
1394
|Wish Upon A Jackpot|
2992
|Wisps|
1051
1052
|Witch Pickings|
976
|Witchcraft 96|
1971
|Witchcraft Academy|
2543
2544
|Wixx|
2636
|Wizard Shop|
1974
|Wizdom Wonders|
3582
|Wolf Cub|
1479
1480
|Wolf Gold|
1503
1504
|Wolf Hunters|
2556
|Wolf Legend Megaways|
3341
|Wolf Moon Rising|
6274
|Wonder Hounds|
1931
|Wunderfest Deluxe|
2688
|Yak, Yeti & Roll|
3151
|Yeti|
2539
|Yokozuna Clash|
6090
|Zodiac|
2306
|Zombie Circus|
2938
|Zoom|
1110
|Zombie Queen|
6708`
*/
export const myChanceCountries = {
    'New Zealand': {
    'code': 'nz',
    'callingCode': '+64',
    'defaultCurrency': 'NZD'
    },
    'Luxembourg': {
    'code': 'lu',
    'callingCode': '+352',
    'defaultCurrency': 'EUR'
    },
    'Canada': {
    'code': 'ca',
    'callingCode': '+1',
    'defaultCurrency': 'CAD'
    },
    'Germany': {
    'code': 'de',
    'callingCode': '+49',
    'defaultCurrency': 'EUR'
    },
    'Austria': {
    'code': 'at',
    'callingCode': '+43',
    'defaultCurrency': 'EUR'
    },
    'Finland': {
    'code': 'fi',
    'callingCode': '+358',
    'defaultCurrency': 'EUR'
    },
    'Iceland': {
    'code': 'is',
    'callingCode': '+354',
    'defaultCurrency': 'EUR'
    },
    'India': {
    'code': 'in',
    'callingCode': '+91',
    'defaultCurrency': 'INR'
    },
    'Norway': {
    'code': 'no',
    'callingCode': '+47',
    'defaultCurrency': 'NOK'
    },
    // 'Slovenia': {
    // 'code': 'si',
    // 'callingCode': '+386',
    // 'defaultCurrency': 'EUR'
    // },
}

export const URL: string = 'URL'
// export const gameList = '[{"name":"100K Drop","id":248},{"name":"2 Hand Casino Holdem","id":344},{"name":"24h (Pulse)","id":268},{"name":"3 Charms Crush","id":269},{"name":"3 Hit Pay (Pulse)","id":270},{"name":"3888 Ways","id":271},{"name":"50 Fortune Fruits","id":400},{"name":"Absolute Super Reels (Pulse)","id":347},{"name":"Admiral Quattro","id":386},{"name":"Aetherial Fortune","id":423},{"name":"African Simba™","id":90},{"name":"African Stampede","id":409},{"name":"Alice Adventure (Pulse)","id":272},{"name":"ALMIGHTY JACKPOTS - Garden of Persephone™","id":91},{"name":"ALMIGHTY JACKPOTS - Realm of Poseidon™","id":92},{"name":"ALMIGHTY REELS - Power of Zeus","id":93},{"name":"Always Hot™ deluxe","id":94},{"name":"Amazing Sevens","id":95},{"name":"Ambiance (Pulse)","id":273},{"name":"American Poker II","id":81},{"name":"American Roulette","id":323},{"name":"American Roulette","id":266},{"name":"American Roulette VIP","id":305},{"name":"American Vertical Roulette","id":306},{"name":"American Vertical Roulette VIP","id":307},{"name":"Ancient Goddess","id":96},{"name":"Ancient Script","id":151},{"name":"Apollo - God of the Sun™","id":97},{"name":"Arcade Bomb","id":152},{"name":"Arctic Race","id":98},{"name":"Asgard\'s Thunder","id":410},{"name":"Asian Fortunes EFJP","id":99},{"name":"Astro Magic (Pulse)","id":21},{"name":"Atlants Wrath of the Ocean","id":308},{"name":"Autumn Queen™","id":100},{"name":"Avalon","id":399},{"name":"Baccarat (A)","id":330},{"name":"Baccarat (B)","id":362},{"name":"Baccarat (Salon Privé)","id":418},{"name":"Baccarat - Punto Banco","id":215},{"name":"Baccarat Control Squeeze","id":332},{"name":"Baccarat Speed (A)","id":333},{"name":"Baccarat Speed (B)","id":364},{"name":"Baccarat Squeeze","id":331},{"name":"BaseGame","id":153},{"name":"Basic Instinct (Pulse)","id":348},{"name":"Bat Stax™","id":101},{"name":"Beauty of Cleopatra","id":102},{"name":"Beetle Jewels","id":275},{"name":"Best Things in Life (Pulse)","id":274},{"name":"Black Jack Casino","id":72},{"name":"Blackbeard The Golden Age","id":309},{"name":"Blackjack","id":398},{"name":"Blackjack","id":328},{"name":"Blackjack","id":3},{"name":"Blackjack Classic Touch","id":397},{"name":"Blackjack Multihand","id":261},{"name":"Blackjack Multihand VIP","id":304},{"name":"Blackjack Portuguese","id":265},{"name":"Blackjack Portuguese VIP","id":316},{"name":"Blackjack RNG","id":346},{"name":"Blackjack Singlehand","id":260},{"name":"Blackjack Singlehand VIP","id":303},{"name":"Blood Pact","id":310},{"name":"Blue Diamond","id":155},{"name":"Book Of Bruno","id":47},{"name":"Book of Fate","id":103},{"name":"Book of Immortals","id":276},{"name":"Book of Kings","id":154},{"name":"Book of Ra","id":372},{"name":"Book of Ra Deluxe","id":387},{"name":"Book of Ra Deluxe 6","id":385},{"name":"Book of Ra Magic","id":373},{"name":"Book of Ra Mystic Fortunes","id":374},{"name":"Book of Ra™ Bingo","id":68},{"name":"Book of Spells","id":43},{"name":"Boost Racers City Edition","id":424},{"name":"Booster","id":259},{"name":"Bruno Bingo","id":69},{"name":"Burning Ice","id":45},{"name":"Burning Ice Deluxe","id":252},{"name":"Captain Venture","id":104},{"name":"Caribbean Holidays","id":105},{"name":"Casa Donatella","id":1},{"name":"Cash Camel","id":277},{"name":"Cash of Lords","id":311},{"name":"Casino Holdem","id":339},{"name":"Cherry trio (Pulse)","id":278},{"name":"Chilli Chilli Bang Bang","id":279},{"name":"Chinese Treasures","id":156},{"name":"Cinderella\'s Ball","id":157},{"name":"Classic Blackjack","id":158},{"name":"Columbus Deluxe","id":375},{"name":"Crazy Genie","id":159},{"name":"Critters","id":33},{"name":"Crystal Clans","id":280},{"name":"Crystal Hot 40","id":60},{"name":"Crystals Of Magic","id":54},{"name":"Dazzle Me","id":391},{"name":"Dead or Alive 2","id":390},{"name":"Deal Or No Deal","id":343},{"name":"Deep Jungle","id":30},{"name":"DeluXXXe Multi","id":425},{"name":"Deuces Wild","id":82},{"name":"Devil\'s Number","id":160},{"name":"Diamond Apple","id":161},{"name":"Diamond Wild (Pulse)","id":349},{"name":"Diamonds","id":39},{"name":"Disco Double","id":258},{"name":"Divine Ways","id":162},{"name":"Dolphin\'s Pearl","id":376},{"name":"Dolphin\'s Pearl Deluxe","id":377},{"name":"DONDBlackjack","id":163},{"name":"Double Ball Roulette","id":325},{"name":"Dragon Tiger","id":336},{"name":"Dragon Warrior™","id":106},{"name":"Dragon\'s Fire","id":166},{"name":"Dragon\'s Luck","id":164},{"name":"Dragon\'s Luck Power Reels","id":165},{"name":"Dragon\'s Luck Stack","id":359},{"name":"Dual Play American Roulette","id":327},{"name":"Dual Play Baccarat","id":335},{"name":"Dual Play Roulette","id":326},{"name":"Egyptian King","id":401},{"name":"Elemental Dragons","id":107},{"name":"Elven Magic","id":167},{"name":"Emerald Diamond","id":185},{"name":"Epic Journey","id":168},{"name":"Esqueleto Mariachi","id":247},{"name":"European Roulette","id":169},{"name":"European Roulette","id":86},{"name":"Eye of Amulet","id":281},{"name":"Eye of The Dragon","id":108},{"name":"Fairy Queen™","id":109},{"name":"Faust","id":378},{"name":"Feather Frenzy","id":110},{"name":"Five Star","id":170},{"name":"FlamingFox","id":172},{"name":"Fluffy Bingo","id":70},{"name":"Forest Fruits","id":51},{"name":"Forest Mania (Pulse)","id":282},{"name":"Fortune Charm","id":174},{"name":"Fortune Diamond","id":16},{"name":"Fortune Fest","id":175},{"name":"Fortune god","id":34},{"name":"Fortune House","id":176},{"name":"Fortune Pig","id":18},{"name":"French Roulette ","id":363},{"name":"French Roulette VIP","id":320},{"name":"Fruit Shop","id":394},{"name":"FruitBlox","id":171},{"name":"Fruits and Stars","id":36},{"name":"Fruits\'n Sevens","id":111},{"name":"Gangster Paradise","id":112},{"name":"Garden of Riches","id":61},{"name":"Gems Gone Wild","id":177},{"name":"Gemtastic","id":178},{"name":"God of Wealth","id":179},{"name":"Goddess Rising™","id":113},{"name":"Gold Star","id":183},{"name":"Golden Ark","id":62},{"name":"Golden Cobras™ deluxe","id":114},{"name":"Golden Lotus","id":180},{"name":"Golden Offer","id":181},{"name":"Golden Sevens","id":413},{"name":"Golden Temple","id":182},{"name":"Gonzos Quests","id":392},{"name":"Gorilla™","id":63},{"name":"Grand Hold\'em","id":75},{"name":"Grand Wheel","id":184},{"name":"Gryphon\'s Gold™ deluxe","id":115},{"name":"Happy Birds (Pulse)","id":283},{"name":"Haul of Hades Super Spinner","id":407},{"name":"Haul of Hades™","id":64},{"name":"Heart Of Egypt","id":116},{"name":"Hey Sweetie","id":426},{"name":"Highlander","id":417},{"name":"Hot Chance™","id":117},{"name":"Hot Fever 2","id":312},{"name":"Hot Shots","id":26},{"name":"Hot Spin","id":12},{"name":"Hot Stars","id":41},{"name":"Illusions 2 (Pulse)","id":284},{"name":"Imperial Palace","id":186},{"name":"Imperial Wealth","id":15},{"name":"Indian Spirit™","id":118},{"name":"Infinite Blackjack","id":329},{"name":"Irish Coins™","id":119},{"name":"Island Heat","id":120},{"name":"Jack in a Pot","id":187},{"name":"Jackpot Dice","id":121},{"name":"Jackpot Rango","id":267},{"name":"Jacks or Better","id":83},{"name":"Jade Charms","id":188},{"name":"Jaguar Moon","id":122},{"name":"Jester spins ","id":189},{"name":"Jewels Match 3","id":76},{"name":"Jingle Bells","id":190},{"name":"Jingle Spin","id":395},{"name":"Jinxy Match 3","id":77},{"name":"Joker Stacks","id":285},{"name":"Joker Wild","id":84},{"name":"Jolly Poker","id":251},{"name":"Juicy Hot","id":40},{"name":"Jumbo Stampede","id":13},{"name":"Just Jewels™ deluxe","id":123},{"name":"Kassius Invictus Armis","id":264},{"name":"Katana™","id":124},{"name":"King of Cards™","id":125},{"name":"Laser Fruit","id":191},{"name":"Legends of Loki","id":286},{"name":"Legends of the Seas","id":126},{"name":"Lightning Dice","id":422},{"name":"Lightning Roulette","id":324},{"name":"Lion Dance","id":192},{"name":"Little Dragons™","id":127},{"name":"Live Blackjack - Lobby","id":254},{"name":"Live European Roulette","id":250},{"name":"Live Roulette - Lobby","id":253},{"name":"Lone Star Jakcpots","id":411},{"name":"Lord of the Ocean","id":379},{"name":"Lords of Asgard","id":427},{"name":"Lost garden","id":5},{"name":"Luck Ness The Slot Game","id":313},{"name":"Lucky 3","id":287},{"name":"Lucky Clover","id":29},{"name":"Lucky Easter","id":194},{"name":"Lucky Fortune Cat","id":173},{"name":"Lucky Halloween","id":195},{"name":"Lucky Lady","id":350},{"name":"Lucky Lady Bingo","id":71},{"name":"Lucky Lady\'s Charm Deluxe","id":388},{"name":"Lucky Lady\'s Charm Deluxe 10","id":380},{"name":"Lucky Lady\'s Charm Deluxe 6","id":381},{"name":"Lucky Leprechaun (Pulse)","id":351},{"name":"Lucky Little Devil","id":193},{"name":"Lucky Mr. Green","id":196},{"name":"Lucky Stripes","id":288},{"name":"Lucky Valentine","id":197},{"name":"Lucky Wizard","id":198},{"name":"Lux Blackjack 6-Decks™","id":73},{"name":"Lux Roulette","id":87},{"name":"Luxury Rome (Pulse)","id":289},{"name":"Magic Gate","id":199},{"name":"Masquerade","id":201},{"name":"Mayan Gods","id":200},{"name":"Mega Dragon","id":202},{"name":"Mega Hot","id":44},{"name":"Mega Jade","id":203},{"name":"Mega Pyramid","id":204},{"name":"Merlin\'s Magic Mirror","id":402},{"name":"Mermaid\'s Pearl","id":412},{"name":"Mermaid’s Pearl™","id":128},{"name":"Midas Gold","id":205},{"name":"Million Cents HD (Pulse)","id":290},{"name":"Million Coins Respins","id":14},{"name":"Mini Roulette ","id":318},{"name":"MojiO.o","id":2},{"name":"Mojo Spin","id":262},{"name":"Mona Lisa Jewels (Pulse)","id":352},{"name":"Money Wheel","id":420},{"name":"Monsters","id":50},{"name":"Musketeer Slot (Pulse)","id":291},{"name":"Mystery of LongWei","id":292},{"name":"Mystery Reels","id":206},{"name":"Mystery Reels Mega Ways","id":207},{"name":"Mystery Roulette™ x38","id":88},{"name":"Mystic Ming Zhi","id":19},{"name":"Mystic Secrets™","id":129},{"name":"Mystic Wheel","id":208},{"name":"Myth of Medusa Gold","id":415},{"name":"Neon Hot 5","id":58},{"name":"Ninja Ways","id":209},{"name":"No Commission Baccarat","id":334},{"name":"Ocean Fortune","id":210},{"name":"One Hundred to One","id":130},{"name":"Paranormal Activity (Pulse)","id":293},{"name":"Pearl of the Orient","id":22},{"name":"Pearl Tracker","id":314},{"name":"Persian Fortune","id":211},{"name":"Pharaoh’s Ring™","id":65},{"name":"Phoenix","id":214},{"name":"Phoenix Fire Power Reels","id":225},{"name":"Piggy Pirates","id":212},{"name":"Pinata Fiesta","id":294},{"name":"Pirate queen","id":6},{"name":"Pirates","id":49},{"name":"Pirates\' Plenty","id":213},{"name":"Plasma Fusion","id":315},{"name":"Platoon Wild Progressive (Pulse)","id":353},{"name":"Postman","id":35},{"name":"Power Stars","id":382},{"name":"Puss\'n Boots","id":216},{"name":"Pyramid","id":38},{"name":"Pyramid Fortunes™","id":131},{"name":"Queen Cleopatra","id":132},{"name":"Queen of Hearts™ deluxe","id":133},{"name":"Ra\'s Legend","id":218},{"name":"Rainbow Jackpots","id":217},{"name":"Rambo (Pulse)","id":354},{"name":"Ramses II","id":134},{"name":"Reactor","id":221},{"name":"Really Wild","id":135},{"name":"Red Diamond","id":220},{"name":"Red Dragon Wild (Pulse)","id":295},{"name":"Reel Heist","id":222},{"name":"Reel King Mega","id":219},{"name":"Relic Heroes","id":263},{"name":"Rings of Fortune","id":136},{"name":"Roaring Forties™","id":66},{"name":"Rocket Men","id":223},{"name":"Roulette","id":361},{"name":"Roulette","id":321},{"name":"Roulette","id":249},{"name":"Roulette","id":17},{"name":"Roulette","id":4},{"name":"Roulette (Immersive)","id":368},{"name":"Roulette (Salon Privé)","id":369},{"name":"Roulette (VIP)","id":367},{"name":"Roulette RNG","id":345},{"name":"Roulette Touch","id":396},{"name":"Royal Cash (Pulse)","id":296},{"name":"Royal Crown 3 Card Brag","id":85},{"name":"Royal Crown Blackjack","id":74},{"name":"Royal Crown European Roulette","id":89},{"name":"Royal Gems","id":224},{"name":"Scrolls of Ra (Pulse)","id":297},{"name":"Scuba view","id":32},{"name":"Secret Trail Match 3","id":78},{"name":"Shaolin Spin (Pulse)","id":298},{"name":"Sherwood Showdown","id":137},{"name":"Shooting Stars™","id":67},{"name":"Side Bet City","id":421},{"name":"Sizzling Hot Deluxe","id":383},{"name":"Slingshot Auto French Roulette","id":322},{"name":"Slingshot Auto Roulette","id":319},{"name":"Slingshot Auto Roulette (Speed)","id":366},{"name":"Slingshot Auto Roulette (VIP)","id":365},{"name":"Slot of Madness","id":428},{"name":"Snow Wild and the 7 Features","id":226},{"name":"Space Guardians","id":56},{"name":"Sparkling Fruit Match 3","id":79},{"name":"Sparkling Fruit Match 3 XMAS EDITION","id":80},{"name":"Speed Roulette","id":419},{"name":"Spin or Reels HD (Pulse)","id":27},{"name":"Spin Town","id":227},{"name":"Spirits of the Valkyrie","id":138},{"name":"Spring Queen","id":139},{"name":"Stacks O\'Gold","id":20},{"name":"Stage 888","id":228},{"name":"Star Gems","id":52},{"name":"Starburst","id":389},{"name":"Starlight","id":57},{"name":"Stein Haus","id":140},{"name":"Summer Queen™","id":141},{"name":"Sumo Spins","id":229},{"name":"Super Cherry 1000","id":405},{"name":"Super Cherry 2000","id":406},{"name":"Super Cherry 5000","id":371},{"name":"Super Diamond Wild","id":299},{"name":"Super Fast Hot Hot (Pulse)","id":355},{"name":"Super Fast Hot Hot Respin","id":24},{"name":"Super Lucky Reels (Pulse)","id":356},{"name":"Super Multitimes Progressive HD (Pulse)","id":357},{"name":"Super Sic Bo","id":342},{"name":"Tales of Darkness - Midnight Heat","id":416},{"name":"Tales of Darkness™ - Break of Dawn","id":142},{"name":"Tales of Darkness™ - Full Moon","id":143},{"name":"Tales of Darkness™ - Lunar Eclipse","id":144},{"name":"Tbd","id":370},{"name":"TBD","id":317},{"name":"Templars Quest","id":55},{"name":"Ten Elements","id":230},{"name":"Texas Holdem Bonus Poker","id":338},{"name":"The Dalai Panda","id":300},{"name":"The Equalizer","id":232},{"name":"The Golden City","id":403},{"name":"The Great Gambini\'s Night Magic™","id":145},{"name":"The Greatest Train Robbery","id":233},{"name":"The King","id":301},{"name":"The Krackener\'z Slot Game","id":429},{"name":"The Love Guru (Pulse)","id":302},{"name":"The Nutcracker","id":28},{"name":"The Ruby","id":358},{"name":"Thor\'s Lightning","id":234},{"name":"Three Card Poker","id":340},{"name":"Three Kingdoms","id":235},{"name":"Three Musketeers","id":236},{"name":"Tidal Riches","id":146},{"name":"Tiki Fruits","id":231},{"name":"Top Card","id":337},{"name":"Totem Lightning","id":237},{"name":"Totem Lightning Power Reels","id":238},{"name":"Treasure Mine","id":239},{"name":"Treasures of the Caribbean","id":8},{"name":"Tree of Fortune","id":23},{"name":"Triple Crown","id":42},{"name":"Triple Hot","id":59},{"name":"Tropical Hot","id":48},{"name":"Turbo Hot 40","id":46},{"name":"Twin Spin","id":393},{"name":"Ultimate Super Reels","id":25},{"name":"Ultimate Texas Holdem","id":341},{"name":"Ultra Hot Deluxe","id":384},{"name":"Vampire Fortunes™","id":147},{"name":"Vicky Ventura","id":240},{"name":"Viking Gold","id":53},{"name":"Viva Cabaret - Xtra Choice","id":408},{"name":"Wild Ape","id":404},{"name":"Wild Circus","id":241},{"name":"Wild Country™","id":148},{"name":"Wild Fight","id":242},{"name":"Wild Nords","id":243},{"name":"Wild Spartans","id":244},{"name":"Wild West","id":37},{"name":"Wild Wild Chest","id":245},{"name":"Winter Queen","id":149},{"name":"Winter Wonders","id":246},{"name":"Wish Upon a Star","id":414},{"name":"Wizard","id":31},{"name":"Xtra Hot™","id":150}]'
// export const gameList = '[{"name":"100K Drop","id":248},{"name":"2 Hand Casino Holdem","id":344},{"name":"24h (Pulse)","id":268},{"name":"3 Charms Crush","id":269},{"name":"3 Hit Pay (Pulse)","id":270},{"name":"3888 Ways","id":271},{"name":"50 Fortune Fruits","id":400},{"name":"Absolute Super Reels (Pulse)","id":347},{"name":"Admiral Quattro","id":386},{"name":"Adventure Palace","id":432},{"name":"Aetherial Fortune","id":423},{"name":"African Simba™","id":90},{"name":"African Stampede","id":409},{"name":"Age of Discovery","id":433},{"name":"Agent Jane Blonde","id":434},{"name":"Agent Jane Blonde Returns","id":435},{"name":"Alice Adventure (Pulse)","id":272},{"name":"ALMIGHTY JACKPOTS - Garden of Persephone™","id":91},{"name":"ALMIGHTY JACKPOTS - Realm of Poseidon™","id":92},{"name":"ALMIGHTY REELS - Power of Zeus","id":93},{"name":"Always Hot™ deluxe","id":94},{"name":"Amazing Sevens","id":95},{"name":"Ambiance (Pulse)","id":273},{"name":"American Poker II","id":81},{"name":"American Roulette","id":323},{"name":"American Roulette","id":266},{"name":"American Roulette VIP","id":305},{"name":"American Vertical Roulette","id":306},{"name":"American Vertical Roulette VIP","id":307},{"name":"Ancient Goddess","id":96},{"name":"Ancient Script","id":151},{"name":"Apollo - God of the Sun™","id":97},{"name":"Arcade Bomb","id":152},{"name":"Arctic Race","id":98},{"name":"Ariana","id":436},{"name":"Asgard\'s Thunder","id":410},{"name":"Asian Fortunes EFJP","id":99},{"name":"Astro Magic (Pulse)","id":21},{"name":"Atlants Wrath of the Ocean","id":308},{"name":"Autumn Queen™","id":100},{"name":"Avalon","id":399},{"name":"Baccarat (A)","id":330},{"name":"Baccarat (B)","id":362},{"name":"Baccarat (Salon Privé)","id":418},{"name":"Baccarat - Punto Banco","id":215},{"name":"Baccarat Control Squeeze","id":332},{"name":"Baccarat Speed (A)","id":333},{"name":"Baccarat Speed (B)","id":364},{"name":"Baccarat Squeeze","id":331},{"name":"Bar Bar Black Sheep - 5 Reel","id":437},{"name":"BaseGame","id":153},{"name":"Basic Instinct (Pulse)","id":348},{"name":"Basketball Star","id":438},{"name":"Bat Stax™","id":101},{"name":"Beautiful Bones","id":439},{"name":"Beauty of Cleopatra","id":102},{"name":"Beetle Jewels","id":275},{"name":"Best Things in Life (Pulse)","id":274},{"name":"Black Jack Casino","id":72},{"name":"Blackbeard The Golden Age","id":309},{"name":"Blackjack","id":398},{"name":"Blackjack","id":328},{"name":"Blackjack","id":3},{"name":"Blackjack Classic Touch","id":397},{"name":"Blackjack Multihand","id":261},{"name":"Blackjack Multihand VIP","id":304},{"name":"Blackjack Portuguese","id":265},{"name":"Blackjack Portuguese VIP","id":316},{"name":"Blackjack RNG","id":346},{"name":"Blackjack Singlehand","id":260},{"name":"Blackjack Singlehand VIP","id":303},{"name":"Blood Pact","id":310},{"name":"Blue Diamond","id":155},{"name":"Book Of Bruno","id":47},{"name":"Book of Fate","id":103},{"name":"Book of Immortals","id":276},{"name":"Book of Kings","id":154},{"name":"Book of Oz","id":440},{"name":"Book of Ra","id":372},{"name":"Book of Ra Deluxe","id":387},{"name":"Book of Ra Deluxe 6","id":385},{"name":"Book of Ra Magic","id":373},{"name":"Book of Ra Mystic Fortunes","id":374},{"name":"Book of Ra™ Bingo","id":68},{"name":"Book of Spells","id":43},{"name":"Boost Racers City Edition","id":424},{"name":"Booster","id":259},{"name":"Break Away","id":441},{"name":"Break Away Deluxe","id":442},{"name":"Break da Bank","id":443},{"name":"Break da Bank Again","id":444},{"name":"Bruno Bingo","id":69},{"name":"Burning Desire","id":445},{"name":"Burning Ice","id":45},{"name":"Burning Ice Deluxe","id":252},{"name":"Bush Telegraph","id":446},{"name":"Captain Venture","id":104},{"name":"Caribbean Holidays","id":105},{"name":"Carnaval","id":447},{"name":"Casa Donatella","id":1},{"name":"Cash Camel","id":277},{"name":"Cash of Kingdoms","id":448},{"name":"Cash of Lords","id":311},{"name":"Casino Holdem","id":339},{"name":"Cherry trio (Pulse)","id":278},{"name":"Chilli Chilli Bang Bang","id":279},{"name":"Chinese Treasures","id":156},{"name":"Cinderella\'s Ball","id":157},{"name":"Classic Blackjack","id":158},{"name":"Classic Blackjack Gold","id":431},{"name":"Columbus Deluxe","id":375},{"name":"Cool Wolf","id":449},{"name":"Crazy Genie","id":159},{"name":"Critters","id":33},{"name":"Crystal Clans","id":280},{"name":"Crystal Hot 40","id":60},{"name":"Crystals Of Magic","id":54},{"name":"Dazzle Me","id":391},{"name":"Dead or Alive 2","id":390},{"name":"Deal Or No Deal","id":343},{"name":"Deep Jungle","id":30},{"name":"DeluXXXe Multi","id":425},{"name":"Deuces Wild","id":82},{"name":"Devil\'s Number","id":160},{"name":"Diamond Apple","id":161},{"name":"Diamond Wild (Pulse)","id":349},{"name":"Diamonds","id":39},{"name":"Disco Double","id":258},{"name":"Divine Ways","id":162},{"name":"Dolphin\'s Pearl","id":376},{"name":"Dolphin\'s Pearl Deluxe","id":377},{"name":"DONDBlackjack","id":163},{"name":"Double Ball Roulette","id":325},{"name":"Double Wammy","id":450},{"name":"Dragon Dance","id":451},{"name":"Dragon Shard","id":452},{"name":"Dragon Tiger","id":336},{"name":"Dragon Warrior™","id":106},{"name":"Dragon\'s Fire","id":166},{"name":"Dragon\'s Luck","id":164},{"name":"Dragon\'s Luck Power Reels","id":165},{"name":"Dragon\'s Luck Stack","id":359},{"name":"Dragonz","id":453},{"name":"Dream Date","id":454},{"name":"Dual Play American Roulette","id":327},{"name":"Dual Play Baccarat","id":335},{"name":"Dual Play Roulette","id":326},{"name":"Egyptian King","id":401},{"name":"Elemental Dragons","id":107},{"name":"Elven Magic","id":167},{"name":"Emerald Diamond","id":185},{"name":"Emperor of the Sea","id":455},{"name":"Epic Journey","id":168},{"name":"Esqueleto Mariachi","id":247},{"name":"European Roulette","id":169},{"name":"European Roulette","id":86},{"name":"Exotic Cats","id":456},{"name":"Eye of Amulet","id":281},{"name":"Eye of The Dragon","id":108},{"name":"Fairy Queen™","id":109},{"name":"Faust","id":378},{"name":"Feather Frenzy","id":110},{"name":"Fish Party","id":457},{"name":"Five Star","id":170},{"name":"FlamingFox","id":172},{"name":"Fluffy Bingo","id":70},{"name":"Football Star","id":458},{"name":"Forest Fruits","id":51},{"name":"Forest Mania (Pulse)","id":282},{"name":"Fortune Charm","id":174},{"name":"Fortune Diamond","id":16},{"name":"Fortune Fest","id":175},{"name":"Fortune Girl","id":459},{"name":"Fortune god","id":34},{"name":"Fortune House","id":176},{"name":"Fortune Pig","id":18},{"name":"Fortunium","id":460},{"name":"French Roulette","id":320},{"name":"French Roulette Gold","id":363},{"name":"Fruit Shop","id":394},{"name":"FruitBlox","id":171},{"name":"Fruits and Stars","id":36},{"name":"Fruits\'n Sevens","id":111},{"name":"Game Of Thrones - Ways","id":461},{"name":"Gangster Paradise","id":112},{"name":"Garden of Riches","id":61},{"name":"Gems Gone Wild","id":177},{"name":"Gemtastic","id":178},{"name":"God of Wealth","id":179},{"name":"Goddess Rising™","id":113},{"name":"Gold Star","id":183},{"name":"Golden Ark","id":62},{"name":"Golden Cobras™ deluxe","id":114},{"name":"Golden Lotus","id":180},{"name":"Golden Offer","id":181},{"name":"Golden Princess","id":462},{"name":"Golden Sevens","id":413},{"name":"Golden Temple","id":182},{"name":"Gonzos Quests","id":392},{"name":"Gorilla™","id":63},{"name":"Grand Hold\'em","id":75},{"name":"Grand Wheel","id":184},{"name":"Gryphon\'s Gold™ deluxe","id":115},{"name":"Happy Birds (Pulse)","id":283},{"name":"Haul of Hades Super Spinner","id":407},{"name":"Haul of Hades™","id":64},{"name":"Heart Of Egypt","id":116},{"name":"Hey Sweetie","id":426},{"name":"High Society","id":463},{"name":"Highlander","id":417},{"name":"Hot Chance™","id":117},{"name":"Hot Fever 2","id":312},{"name":"Hot Shots","id":26},{"name":"Hot Spin","id":12},{"name":"Hot Stars","id":41},{"name":"Illusions 2 (Pulse)","id":284},{"name":"Immortal Romance","id":464},{"name":"Imperial Palace","id":186},{"name":"Imperial Wealth","id":15},{"name":"Indian Spirit™","id":118},{"name":"Infinite Blackjack","id":329},{"name":"Irish Coins™","id":119},{"name":"Isis","id":465},{"name":"Island Heat","id":120},{"name":"Jack in a Pot","id":187},{"name":"Jackpot Dice","id":121},{"name":"Jackpot Rango","id":267},{"name":"Jacks or Better","id":83},{"name":"Jacks or Better Poker","id":466},{"name":"Jade Charms","id":188},{"name":"Jaguar Moon","id":122},{"name":"Jester spins ","id":189},{"name":"Jewels Match 3","id":76},{"name":"Jingle Bells","id":190},{"name":"Jingle Spin","id":395},{"name":"Jinxy Match 3","id":77},{"name":"Joker Stacks","id":285},{"name":"Joker Wild","id":84},{"name":"Jolly Poker","id":251},{"name":"Juicy Hot","id":40},{"name":"Jumbo Stampede","id":13},{"name":"Jungle Jim - El Dorado","id":467},{"name":"Jurassic World","id":468},{"name":"Just Jewels™ deluxe","id":123},{"name":"Kassius Invictus Armis","id":264},{"name":"Katana™","id":124},{"name":"King of Cards™","id":125},{"name":"King Tusk","id":469},{"name":"Laser Fruit","id":191},{"name":"Le Kaffee Bar","id":470},{"name":"Legends of Loki","id":286},{"name":"Legends of the Seas","id":126},{"name":"Lightning Dice","id":422},{"name":"Lightning Roulette","id":324},{"name":"Lion Dance","id":192},{"name":"Little Dragons™","id":127},{"name":"Live European Roulette","id":250},{"name":"Lone Star Jakcpots","id":411},{"name":"Lord of the Ocean","id":379},{"name":"Lords of Asgard","id":427},{"name":"Lost garden","id":5},{"name":"Love Island","id":471},{"name":"Lucha Legends","id":472},{"name":"Luck Ness The Slot Game","id":313},{"name":"Lucky 3","id":287},{"name":"Lucky Clover","id":29},{"name":"Lucky Easter","id":194},{"name":"Lucky Fortune Cat","id":173},{"name":"Lucky Halloween","id":195},{"name":"Lucky Koi","id":473},{"name":"Lucky Lady","id":350},{"name":"Lucky Lady Bingo","id":71},{"name":"Lucky Lady\'s Charm Deluxe","id":388},{"name":"Lucky Lady\'s Charm Deluxe 10","id":380},{"name":"Lucky Lady\'s Charm Deluxe 6","id":381},{"name":"Lucky Leprechaun","id":474},{"name":"Lucky Leprechaun (Pulse)","id":351},{"name":"Lucky Little Devil","id":193},{"name":"Lucky Little Gods","id":475},{"name":"Lucky Mr. Green","id":196},{"name":"Lucky Stripes","id":288},{"name":"Lucky Valentine","id":197},{"name":"Lucky Wizard","id":198},{"name":"Lux Blackjack 6-Decks™","id":73},{"name":"Lux Roulette","id":87},{"name":"Luxury Rome (Pulse)","id":289},{"name":"Magic Gate","id":199},{"name":"Masquerade","id":201},{"name":"Mayan Gods","id":200},{"name":"Mega Dragon","id":202},{"name":"Mega Hot","id":44},{"name":"Mega Jade","id":203},{"name":"Mega Pyramid","id":204},{"name":"Merlin\'s Magic Mirror","id":402},{"name":"Mermaid\'s Pearl","id":412},{"name":"Mermaids Millions","id":476},{"name":"Mermaid’s Pearl™","id":128},{"name":"Midas Gold","id":205},{"name":"Million Cents HD (Pulse)","id":290},{"name":"Million Coins Respins","id":14},{"name":"Mini Roulette ","id":318},{"name":"MojiO.o","id":2},{"name":"Mojo Spin","id":262},{"name":"Mona Lisa Jewels (Pulse)","id":352},{"name":"Money Wheel","id":420},{"name":"Monster Wheels","id":477},{"name":"Monsters","id":50},{"name":"Musketeer Slot (Pulse)","id":291},{"name":"Mystery of LongWei","id":292},{"name":"Mystery Reels","id":206},{"name":"Mystery Reels Mega Ways","id":207},{"name":"Mystery Roulette™ x38","id":88},{"name":"Mystic Ming Zhi","id":19},{"name":"Mystic Secrets™","id":129},{"name":"Mystic Wheel","id":208},{"name":"Myth of Medusa Gold","id":415},{"name":"Neon Hot 5","id":58},{"name":"Ninja Ways","id":209},{"name":"No Commission Baccarat","id":334},{"name":"Ocean Fortune","id":210},{"name":"One Hundred to One","id":130},{"name":"Paranormal Activity (Pulse)","id":293},{"name":"Pearl of the Orient","id":22},{"name":"Pearl Tracker","id":314},{"name":"Persian Fortune","id":211},{"name":"Pharaoh’s Ring™","id":65},{"name":"Phoenix","id":214},{"name":"Phoenix Fire Power Reels","id":225},{"name":"Piggy Pirates","id":212},{"name":"Pinata Fiesta","id":294},{"name":"Pirate queen","id":6},{"name":"Pirates","id":49},{"name":"Pirates\' Plenty","id":213},{"name":"Plasma Fusion","id":315},{"name":"Platoon Wild Progressive (Pulse)","id":353},{"name":"Playboy","id":478},{"name":"Postman","id":35},{"name":"Power Stars","id":382},{"name":"Puss\'n Boots","id":216},{"name":"Pyramid","id":38},{"name":"Pyramid Fortunes™","id":131},{"name":"Queen Cleopatra","id":132},{"name":"Queen of Hearts™ deluxe","id":133},{"name":"Ra\'s Legend","id":218},{"name":"Rainbow Jackpots","id":217},{"name":"Rambo (Pulse)","id":354},{"name":"Ramses II","id":134},{"name":"Reactor","id":221},{"name":"Really Wild","id":135},{"name":"Red Diamond","id":220},{"name":"Red Dragon Wild (Pulse)","id":295},{"name":"Reel Heist","id":222},{"name":"Reel King Mega","id":219},{"name":"Relic Heroes","id":263},{"name":"Retro Reels - Extreme Heat","id":479},{"name":"Rings of Fortune","id":136},{"name":"Roaring Forties™","id":66},{"name":"Rocket Men","id":223},{"name":"Roulette","id":361},{"name":"Roulette","id":249},{"name":"Roulette","id":17},{"name":"Roulette","id":4},{"name":"Roulette (Immersive)","id":368},{"name":"Roulette (Salon Privé)","id":369},{"name":"Roulette (VIP)","id":367},{"name":"Roulette RNG","id":345},{"name":"Roulette Touch","id":396},{"name":"Royal Cash (Pulse)","id":296},{"name":"Royal Crown 3 Card Brag","id":85},{"name":"Royal Crown Blackjack","id":74},{"name":"Royal Crown European Roulette","id":89},{"name":"Royal Gems","id":224},{"name":"Rugby Star","id":480},{"name":"Scrolls of Ra (Pulse)","id":297},{"name":"Scuba view","id":32},{"name":"Secret Trail Match 3","id":78},{"name":"Shaolin Spin (Pulse)","id":298},{"name":"Sherwood Showdown","id":137},{"name":"Shooting Stars™","id":67},{"name":"Showdown Saloon","id":481},{"name":"Side Bet City","id":421},{"name":"Six Acrobats","id":482},{"name":"Sizzling Hot Deluxe","id":383},{"name":"Slingshot Auto French Roulette","id":322},{"name":"Slingshot Auto Roulette","id":319},{"name":"Slingshot Auto Roulette (Speed)","id":366},{"name":"Slingshot Auto Roulette (VIP)","id":365},{"name":"Slot of Madness","id":428},{"name":"Snow Wild and the 7 Features","id":226},{"name":"Space Guardians","id":56},{"name":"Sparkling Fruit Match 3","id":79},{"name":"Sparkling Fruit Match 3 XMAS EDITION","id":80},{"name":"Speed Roulette","id":419},{"name":"Spin or Reels HD (Pulse)","id":27},{"name":"Spin Town","id":227},{"name":"Spirits of the Valkyrie","id":138},{"name":"Spring Break","id":483},{"name":"Spring Queen","id":139},{"name":"Stacks O\'Gold","id":20},{"name":"Stage 888","id":228},{"name":"Star Gems","id":52},{"name":"Starburst","id":389},{"name":"Starlight","id":57},{"name":"Starlight Kiss","id":484},{"name":"Stein Haus","id":140},{"name":"Summer Queen™","id":141},{"name":"Sumo Spins","id":229},{"name":"SunTide","id":485},{"name":"Super Cherry 1000","id":405},{"name":"Super Cherry 2000","id":406},{"name":"Super Cherry 5000","id":371},{"name":"Super Diamond Wild","id":299},{"name":"Super Fast Hot Hot (Pulse)","id":355},{"name":"Super Fast Hot Hot Respin","id":24},{"name":"Super Lucky Reels (Pulse)","id":356},{"name":"Super Multitimes Progressive HD (Pulse)","id":357},{"name":"Super Sic Bo","id":342},{"name":"Tales of Darkness - Midnight Heat","id":416},{"name":"Tales of Darkness™ - Break of Dawn","id":142},{"name":"Tales of Darkness™ - Full Moon","id":143},{"name":"Tales of Darkness™ - Lunar Eclipse","id":144},{"name":"Tarzan","id":486},{"name":"Templars Quest","id":55},{"name":"Ten Elements","id":230},{"name":"Texas Holdem Bonus Poker","id":338},{"name":"The Dalai Panda","id":300},{"name":"The Equalizer","id":232},{"name":"The Finer Reels of Life","id":487},{"name":"The Golden City","id":403},{"name":"The Great Gambini\'s Night Magic™","id":145},{"name":"The Greatest Train Robbery","id":233},{"name":"The King","id":301},{"name":"The Krackener\'z Slot Game","id":429},{"name":"The Love Guru (Pulse)","id":302},{"name":"The Nutcracker","id":28},{"name":"The Ruby","id":358},{"name":"The Twisted Circus","id":488},{"name":"Thor\'s Lightning","id":234},{"name":"Three Card Poker","id":340},{"name":"Three Kingdoms","id":235},{"name":"Three Musketeers","id":236},{"name":"Thunderstruck","id":430},{"name":"Thunderstruck II","id":489},{"name":"Tidal Riches","id":146},{"name":"Tiki Fruits","id":231},{"name":"Top Card","id":337},{"name":"Totem Lightning","id":237},{"name":"Totem Lightning Power Reels","id":238},{"name":"Treasure Mine","id":239},{"name":"Treasures of the Caribbean","id":8},{"name":"Tree of Fortune","id":23},{"name":"Triple Crown","id":42},{"name":"Triple Hot","id":59},{"name":"Tropical Hot","id":48},{"name":"Turbo Hot 40","id":46},{"name":"Twin Spin","id":393},{"name":"Ultimate Super Reels","id":25},{"name":"Ultimate Texas Holdem","id":341},{"name":"Ultra Hot Deluxe","id":384},{"name":"Vampire Fortunes™","id":147},{"name":"Vicky Ventura","id":240},{"name":"Viking Gold","id":53},{"name":"Viva Cabaret - Xtra Choice","id":408},{"name":"Wacky Panda","id":490},{"name":"Wild Ape","id":404},{"name":"Wild Circus","id":241},{"name":"Wild Country™","id":148},{"name":"Wild Fight","id":242},{"name":"Wild Nords","id":243},{"name":"Wild Orient","id":491},{"name":"Wild Scarabs","id":492},{"name":"Wild Spartans","id":244},{"name":"Wild West","id":37},{"name":"Wild Wild Chest","id":245},{"name":"Winter Queen","id":149},{"name":"Winter Wonders","id":246},{"name":"Wish Upon a Star","id":414},{"name":"Wizard","id":31},{"name":"Xtra Hot™","id":150},{"name":"Zombie Hoard","id":493}]'